var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCostaRica(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5819_33118",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 18
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5819_33118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.75 3H29.25V21H-0.75V3Z",
    fill: "#002B7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.75 6.00001H29.25V17.9999H-0.75V6.00001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.75 9.00012H29.25V15.0002H-0.75V9.00012Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 14.625C9.49264 14.625 10.5 13.4497 10.5 12C10.5 10.5502 9.49264 9.37499 8.25 9.37499C7.00736 9.37499 6 10.5502 6 12C6 13.4497 7.00736 14.625 8.25 14.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.81436 11.6463L6.86512 11.5529L6.74514 11.5194L6.70822 11.6025L6.81436 11.6463ZM9.68575 11.6463L9.63499 11.5529L9.75496 11.5194L9.79188 11.6025L9.68575 11.6463Z",
    fill: "#CEA849",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.21775 10.4562L8.03273 10.4615C7.91459 10.4727 7.86968 10.5182 7.94304 10.6044C7.75258 10.6343 7.56631 10.6778 7.39418 10.7688C7.34579 10.7608 7.2896 10.7879 7.27348 10.8345C7.26004 10.8721 7.2928 10.9122 7.35106 10.8963C7.31252 10.9977 6.85734 10.9859 6.84576 11.1549C6.88024 11.1255 6.9182 11.1006 6.95607 11.1258L6.92997 11.2047C6.86369 11.2245 6.81712 11.2354 6.78937 11.3079C6.7607 11.3807 6.71955 11.4917 6.69088 11.5464C6.67205 11.5716 6.66751 11.5984 6.66751 11.6118C6.66751 11.6432 6.68998 11.6871 6.74192 11.6871C6.79479 11.6871 6.82081 11.654 6.82081 11.6207C6.81773 11.5975 6.80861 11.5703 6.75274 11.5735C6.84651 11.551 6.92757 11.5825 6.98203 11.6172C7.05727 11.6728 7.0761 11.7805 7.03221 11.8691C6.98919 11.9552 6.87987 12.0054 6.71683 11.9418C6.58423 11.8897 6.45083 11.9579 6.40693 12.0764C6.20715 12.617 6.55648 13.0554 6.95247 13.3111C7.36457 13.5774 7.43797 13.6499 7.54817 13.7801C7.65924 13.91 7.76676 14.0588 7.92801 14.0588C7.9531 14.0588 7.9773 14.0516 7.99881 14.0399C8.10031 14.0399 8.1069 14.0778 8.2431 14.0801V14.0803C8.24546 14.0803 8.24773 14.0802 8.25002 14.0801C8.25229 14.0802 8.25446 14.0803 8.2568 14.0803V14.0801C8.39313 14.0778 8.39969 14.0399 8.50123 14.0399C8.52274 14.0516 8.5468 14.0588 8.57189 14.0588C8.73313 14.0588 8.84065 13.91 8.95172 13.7801C9.06192 13.6499 9.13548 13.5774 9.54756 13.3111C9.94354 13.0554 10.2929 12.6169 10.0931 12.0764C10.0492 11.9579 9.91567 11.8897 9.78306 11.9418C9.62002 12.0054 9.51085 11.9552 9.46782 11.8691C9.42393 11.7805 9.44276 11.6728 9.51801 11.6172C9.57247 11.5825 9.65338 11.551 9.74715 11.5735C9.69129 11.5703 9.6823 11.5975 9.67923 11.6207C9.67923 11.654 9.70525 11.6871 9.75811 11.6871C9.81006 11.6871 9.83238 11.6432 9.83238 11.6117C9.83238 11.5984 9.82799 11.5716 9.80916 11.5464C9.7805 11.4917 9.73919 11.3807 9.71052 11.3079C9.68277 11.2354 9.6362 11.2245 9.56992 11.2047L9.54397 11.1258C9.58184 11.1006 9.6198 11.1255 9.65428 11.1549C9.64271 10.9859 9.18738 10.9977 9.14884 10.8963C9.2071 10.9122 9.24001 10.8721 9.22657 10.8345C9.21045 10.7879 9.15426 10.7608 9.10587 10.7688C8.93389 10.6778 8.74746 10.6343 8.55701 10.6044C8.63034 10.5182 8.58544 10.4727 8.46731 10.4615L8.28229 10.4562L8.24999 10.4552L8.21783 10.4562L8.21775 10.4562Z",
    fill: "#DCA842",
    stroke: "black",
    strokeWidth: 0.24008,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95746 11.0406C7.11119 10.9974 7.2768 11.0324 7.37739 10.9864C7.47798 10.9405 7.49963 10.7885 7.39123 10.7684M8.0142 10.4638C8.1922 10.4644 8.15271 10.6768 7.99113 10.6865C7.79201 10.7097 7.5472 10.7032 7.4143 10.758L8.0142 10.4638Z",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54274 11.0406C9.38901 10.9974 9.2234 11.0324 9.12281 10.9864C9.02222 10.9405 9.00057 10.7885 9.10897 10.7684M7.93921 10.6046C7.97465 10.5964 8.01253 10.5951 8.03141 10.5779C8.05028 10.5607 8.05592 10.5299 8.01073 10.5261L7.93921 10.6046ZM7.3509 10.8976C7.38394 10.842 7.37322 10.8032 7.33005 10.8299L7.3509 10.8976ZM8.486 10.4638C8.308 10.4644 8.34748 10.6768 8.50907 10.6865C8.70818 10.7097 8.953 10.7032 9.08589 10.758L8.486 10.4638Z",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33987 13.4604C7.62476 13.6618 7.66597 13.9238 7.96072 13.9363M8.56099 10.6046C8.52555 10.5964 8.48767 10.5951 8.46879 10.5779C8.44992 10.5607 8.44428 10.5299 8.48947 10.5261L8.56099 10.6046ZM9.14926 10.8976C9.11621 10.842 9.12694 10.8032 9.17011 10.8299L9.14926 10.8976Z",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96429 13.9774C7.7905 14.0149 7.67672 13.9204 7.53964 13.7152C7.46973 13.6119 7.28612 13.4665 6.97256 13.2705C6.47981 12.9629 6.3338 12.4264 6.49416 12.1322C6.53358 12.0599 6.63481 12.0314 6.69305 12.0476C6.84445 12.0884 7.09889 12.0476 7.09978 11.8023C7.10068 11.6642 6.98779 11.5029 6.84177 11.5029C6.75306 11.5029 6.70559 11.5323 6.68231 11.5636",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16026 13.4604C8.8754 13.6618 8.83419 13.9238 8.53854 13.9364M7.94279 13.8731C7.94279 13.8597 7.95442 13.8455 7.97146 13.8455C7.98847 13.8455 8.0037 13.8606 8.0037 13.8793C8.0037 13.9204 7.9804 13.9425 7.93114 13.9327C7.89082 13.9247 7.87291 13.8811 7.88993 13.8373C7.90694 13.7928 7.96428 13.7652 8.02608 13.7928C8.08792 13.8213 8.08073 13.9158 8.05925 13.9694C8.0467 14.0005 8.02161 14.0265 7.99116 14.0434L7.94279 13.8731Z",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53586 13.9774C8.70965 14.0148 8.82343 13.9204 8.96048 13.7152C9.02947 13.6119 9.21402 13.4665 9.52757 13.2705C10.0203 12.9629 10.1663 12.4264 10.006 12.1322C9.96657 12.0599 9.86534 12.0314 9.80711 12.0476C9.6557 12.0884 9.40127 12.0476 9.40037 11.8023C9.39948 11.6642 9.51236 11.5029 9.65838 11.5029C9.74707 11.5029 9.79456 11.5323 9.81784 11.5636",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6165 13.8668C8.6165 13.7447 8.40956 13.7063 8.251 13.7063C8.09333 13.7063 7.8855 13.7447 7.8855 13.8668",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55735 13.8731C8.55735 13.8597 8.54573 13.8455 8.52869 13.8455C8.51167 13.8455 8.49644 13.8606 8.49644 13.8793C8.49644 13.9204 8.51975 13.9425 8.56901 13.9327C8.60932 13.9247 8.62724 13.8811 8.61022 13.8373C8.5932 13.7928 8.53587 13.7652 8.47406 13.7928C8.41223 13.8213 8.41941 13.9158 8.4409 13.9694C8.45344 14.0005 8.47853 14.0265 8.50899 14.0434",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45162 13.9897C8.3683 13.9897 8.37099 14.0795 8.25005 14.0795C8.13002 14.0795 8.1327 13.9897 8.04938 13.9897",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25006 13.8558C8.19094 13.8558 8.19094 13.9436 8.25006 13.9436C8.30918 13.9436 8.31008 13.8558 8.25006 13.8558Z",
    fill: "url(#paint0_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35667 13.872C8.31995 13.872 8.31995 13.9266 8.35667 13.9266C8.39341 13.9266 8.39431 13.872 8.35667 13.872Z",
    fill: "url(#paint1_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27786 14.0074C8.27786 13.9704 8.22321 13.9704 8.22321 14.0074C8.22321 14.0441 8.27786 14.0441 8.27786 14.0074Z",
    fill: "url(#paint2_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14346 13.9285C8.18018 13.9285 8.18018 13.8737 8.14346 13.8737C8.10672 13.8737 8.10583 13.9285 8.14346 13.9285Z",
    fill: "url(#paint3_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22226 13.7932C8.22226 13.8299 8.27691 13.8299 8.27691 13.7932C8.27691 13.7565 8.22226 13.7565 8.22226 13.7932Z",
    fill: "url(#paint4_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03906 11.2925C7.04911 11.293 7.05933 11.2956 7.06877 11.2995C7.08545 11.3066 7.10008 11.3186 7.10526 11.3353C7.10529 11.3354 7.10537 11.3355 7.1054 11.3356C7.25266 11.7442 7.1739 11.9184 7.0431 12.1828C6.8541 12.5635 6.99186 13.1307 7.414 13.3787C7.62154 13.5 7.78158 13.5414 7.90416 13.5721C7.96545 13.5874 8.01749 13.6001 8.06149 13.6189C8.10395 13.6371 8.14777 13.6697 8.17545 13.7074C8.13304 13.7109 8.06382 13.7226 8.02984 13.7325C7.98045 13.6698 7.85622 13.6121 7.72766 13.5683C7.5991 13.5246 7.46497 13.4935 7.39223 13.4791H7.39209C7.15544 13.4104 6.93478 13.2564 6.76857 13.0607C6.59259 12.8536 6.50265 12.57 6.5374 12.2856C6.54519 12.2205 6.57105 12.1808 6.60791 12.1591C6.64478 12.1375 6.69142 12.1338 6.74087 12.1371C6.83075 12.1423 6.91881 12.1177 6.99929 12.0681C7.10306 12.0042 7.14559 11.8913 7.14393 11.7686C7.14227 11.646 7.09593 11.5142 7.02251 11.416C6.99627 11.3807 6.98577 11.3542 6.98631 11.3337C6.98686 11.3132 7.00017 11.2996 7.01645 11.2949C7.02059 11.2937 7.02485 11.2929 7.02914 11.2926C7.03245 11.2923 7.03578 11.2923 7.03909 11.2925L7.03906 11.2925Z",
    fill: "#825123",
    stroke: "black",
    strokeWidth: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6643 12.1699C6.59352 12.1699 6.59352 12.2756 6.6643 12.2756C6.73507 12.2756 6.73596 12.1699 6.6643 12.1699Z",
    fill: "url(#paint5_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79689 12.1633C6.72612 12.1633 6.72612 12.2691 6.79689 12.2691C6.86767 12.2691 6.86856 12.1633 6.79689 12.1633Z",
    fill: "url(#paint6_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92766 12.1699C6.85689 12.1699 6.85689 12.2756 6.92766 12.2756C6.99844 12.2756 6.99933 12.1699 6.92766 12.1699Z",
    fill: "url(#paint7_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61586 12.2873C6.54509 12.2873 6.54509 12.3928 6.61586 12.3928C6.68664 12.3928 6.68753 12.2873 6.61586 12.2873Z",
    fill: "url(#paint8_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74672 12.2873C6.67595 12.2873 6.67595 12.3928 6.74672 12.3928C6.8175 12.3928 6.81839 12.2873 6.74672 12.2873Z",
    fill: "url(#paint9_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87841 12.2873C6.80763 12.2873 6.80763 12.3928 6.87841 12.3928C6.94918 12.3928 6.95008 12.2873 6.87841 12.2873Z",
    fill: "url(#paint10_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61052 12.41C6.53975 12.41 6.53975 12.5158 6.61052 12.5158C6.6813 12.5158 6.68219 12.41 6.61052 12.41Z",
    fill: "url(#paint11_radial_5819_33118)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61052 12.41C6.53975 12.41 6.53975 12.5158 6.61052 12.5158C6.6813 12.5158 6.68219 12.41 6.61052 12.41",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73418 12.4054C6.66341 12.4054 6.66341 12.5111 6.73418 12.5111C6.80496 12.5111 6.80585 12.4054 6.73418 12.4054Z",
    fill: "url(#paint12_radial_5819_33118)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73418 12.4054C6.66341 12.4054 6.66341 12.5111 6.73418 12.5111C6.80496 12.5111 6.80585 12.4054 6.73418 12.4054",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86583 12.4054C6.79506 12.4054 6.79506 12.5111 6.86583 12.5111C6.93661 12.5111 6.9375 12.4054 6.86583 12.4054Z",
    fill: "url(#paint13_radial_5819_33118)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86583 12.4054C6.79506 12.4054 6.79506 12.5111 6.86583 12.5111C6.93661 12.5111 6.9375 12.4054 6.86583 12.4054",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62937 12.5355C6.56306 12.5355 6.56306 12.6348 6.62937 12.6348C6.69654 12.6348 6.69744 12.5355 6.62937 12.5355Z",
    fill: "url(#paint14_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75301 12.5355C6.68673 12.5355 6.68673 12.6348 6.75301 12.6348C6.82021 12.6348 6.82021 12.5355 6.75301 12.5355Z",
    fill: "url(#paint15_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87749 12.5355C6.81119 12.5355 6.81119 12.6348 6.87749 12.6348C6.94469 12.6348 6.94558 12.5355 6.87749 12.5355Z",
    fill: "url(#paint16_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65572 12.6651C6.59212 12.6676 6.5966 12.7628 6.6602 12.76C6.72381 12.7573 6.72023 12.6614 6.65572 12.6651Z",
    fill: "url(#paint17_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76824 12.6518C6.70464 12.6545 6.70911 12.7495 6.77273 12.7467C6.83633 12.7442 6.83275 12.6492 6.76824 12.6518Z",
    fill: "url(#paint18_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88737 12.6464C6.82375 12.6492 6.82822 12.7441 6.89184 12.7414C6.95544 12.7386 6.95186 12.6428 6.88737 12.6464Z",
    fill: "url(#paint19_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70102 12.7762C6.64008 12.7808 6.64637 12.8712 6.70728 12.8668C6.76819 12.8632 6.76283 12.7719 6.70102 12.7762Z",
    fill: "url(#paint20_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80401 12.762C6.74578 12.7655 6.75204 12.8524 6.80938 12.849C6.86761 12.8453 6.86225 12.7584 6.80401 12.762Z",
    fill: "url(#paint21_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91331 12.7566C6.86673 12.7593 6.87122 12.8302 6.9178 12.8265C6.96438 12.8238 6.9608 12.754 6.91331 12.7566Z",
    fill: "url(#paint22_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74762 12.8767C6.68939 12.8801 6.69565 12.9671 6.75298 12.9636C6.81122 12.96 6.80585 12.873 6.74762 12.8767Z",
    fill: "url(#paint23_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84705 12.8533C6.79866 12.857 6.80405 12.9294 6.85153 12.926C6.89991 12.9223 6.89542 12.8499 6.84705 12.8533Z",
    fill: "url(#paint24_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93932 12.8409C6.899 12.8425 6.9035 12.9035 6.9429 12.9008C6.98321 12.8989 6.97964 12.8382 6.93932 12.8409Z",
    fill: "url(#paint25_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78879 12.9671C6.73592 12.9788 6.75384 13.0586 6.8067 13.046C6.85956 13.0343 6.84163 12.9556 6.78879 12.9671Z",
    fill: "url(#paint26_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87662 12.9322C6.83273 12.9421 6.84795 13.0084 6.89095 12.9976C6.93485 12.9877 6.92051 12.9214 6.87662 12.9322Z",
    fill: "url(#paint27_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95994 12.9072C6.9232 12.9152 6.93574 12.9707 6.97249 12.9618C7.0092 12.9538 6.99666 12.8983 6.95994 12.9072Z",
    fill: "url(#paint28_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84616 13.0487C6.79956 13.0647 6.82465 13.1356 6.87125 13.1186C6.91783 13.1024 6.89363 13.0317 6.84616 13.0487Z",
    fill: "url(#paint29_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92316 13.0065C6.88374 13.02 6.90525 13.0792 6.94378 13.0648C6.98318 13.0515 6.96258 12.9923 6.92316 13.0065Z",
    fill: "url(#paint30_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99666 12.9753C6.96441 12.9859 6.98143 13.0352 7.01368 13.0235C7.04594 13.012 7.02891 12.9627 6.99666 12.9753Z",
    fill: "url(#paint31_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8954 13.1177C6.85419 13.1365 6.88285 13.1982 6.92406 13.1785C6.96528 13.1606 6.93661 13.0989 6.8954 13.1177Z",
    fill: "url(#paint32_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96172 13.0728C6.92766 13.0881 6.95186 13.14 6.985 13.1239C7.01905 13.1088 6.99575 13.0567 6.96172 13.0728Z",
    fill: "url(#paint33_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.02532 13.0379C6.99665 13.0515 7.01727 13.0934 7.04504 13.0808C7.07371 13.0675 7.05398 13.0244 7.02532 13.0379Z",
    fill: "url(#paint34_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95724 13.1751C6.92319 13.1921 6.95006 13.2439 6.98321 13.226C7.01726 13.209 6.99128 13.1572 6.95724 13.1751Z",
    fill: "url(#paint35_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.01184 13.1347C6.98318 13.1489 7.00558 13.192 7.03335 13.1767C7.06202 13.1625 7.03962 13.1193 7.01184 13.1347Z",
    fill: "url(#paint36_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06473 13.1024C7.04143 13.115 7.06026 13.1498 7.08264 13.1374C7.10595 13.1257 7.08803 13.0891 7.06473 13.1024Z",
    fill: "url(#paint37_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00919 13.2251C6.97963 13.2439 7.00919 13.2888 7.03786 13.2691C7.06742 13.2503 7.03875 13.2053 7.00919 13.2251Z",
    fill: "url(#paint38_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05487 13.184C7.03069 13.2001 7.05487 13.2368 7.07906 13.2207C7.10325 13.2047 7.07906 13.1668 7.05487 13.184Z",
    fill: "url(#paint39_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10056 13.1489C7.07994 13.1625 7.10056 13.193 7.12026 13.1794C7.14085 13.1661 7.12026 13.1356 7.10056 13.1489Z",
    fill: "url(#paint40_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0604 13.2664C7.03084 13.2862 7.0604 13.33 7.08907 13.3103C7.11863 13.2914 7.08996 13.2467 7.0604 13.2664Z",
    fill: "url(#paint41_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1061 13.226C7.08193 13.2423 7.1061 13.279 7.1303 13.2627C7.15449 13.2466 7.1303 13.2099 7.1061 13.226Z",
    fill: "url(#paint42_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1436 13.1911C7.123 13.2047 7.1436 13.2349 7.16332 13.2216C7.18392 13.2081 7.16332 13.1767 7.1436 13.1911Z",
    fill: "url(#paint43_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18385 13.234C7.16504 13.2457 7.18385 13.2744 7.20178 13.2627C7.22059 13.2503 7.20178 13.2216 7.18385 13.234Z",
    fill: "url(#paint44_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15072 13.2709C7.13013 13.2842 7.15072 13.3147 7.17042 13.3012C7.19104 13.2879 7.17042 13.2574 7.15072 13.2709Z",
    fill: "url(#paint45_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11494 13.3085C7.09256 13.3237 7.11494 13.3569 7.13645 13.3416C7.15885 13.3273 7.13645 13.2932 7.11494 13.3085Z",
    fill: "url(#paint46_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22598 13.278C7.20897 13.2897 7.22598 13.3147 7.243 13.3039C7.26004 13.2922 7.243 13.2663 7.22598 13.278Z",
    fill: "url(#paint47_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19958 13.3103C7.18078 13.3229 7.19958 13.3506 7.21749 13.338C7.23632 13.3256 7.21749 13.2979 7.19958 13.3103Z",
    fill: "url(#paint48_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16738 13.3422C7.14766 13.3546 7.16738 13.3851 7.18708 13.3718C7.2068 13.3582 7.18708 13.3287 7.16738 13.3422Z",
    fill: "url(#paint49_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26682 13.3073C7.2516 13.3172 7.26682 13.3415 7.28205 13.3307C7.29728 13.3208 7.28205 13.2967 7.26682 13.3073Z",
    fill: "url(#paint50_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24278 13.3373C7.22576 13.349 7.24278 13.3749 7.2598 13.3634C7.27681 13.3517 7.2598 13.3258 7.24278 13.3373Z",
    fill: "url(#paint51_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21362 13.3715C7.19571 13.3832 7.21362 13.4119 7.23153 13.3983C7.24945 13.3866 7.23153 13.358 7.21362 13.3715Z",
    fill: "url(#paint52_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30032 13.3336C7.28598 13.3443 7.30213 13.3659 7.31646 13.3551C7.3299 13.3443 7.31465 13.3228 7.30032 13.3336Z",
    fill: "url(#paint53_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2786 13.3617C7.26337 13.3734 7.28039 13.3966 7.29562 13.3849C7.31085 13.3734 7.29383 13.35 7.2786 13.3617Z",
    fill: "url(#paint54_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25773 13.3918C7.2416 13.4044 7.25952 13.4303 7.27653 13.417C7.29265 13.4044 7.27474 13.3785 7.25773 13.3918Z",
    fill: "url(#paint55_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33281 13.3542C7.32116 13.364 7.33639 13.3822 7.34804 13.3714C7.35967 13.3606 7.34444 13.3436 7.33281 13.3542Z",
    fill: "url(#paint56_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31492 13.3841C7.30327 13.3946 7.3194 13.4144 7.33194 13.402C7.34448 13.3912 7.32746 13.3715 7.31492 13.3841Z",
    fill: "url(#paint57_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29831 13.4124C7.28487 13.425 7.30279 13.4447 7.31622 13.4321C7.32966 13.4206 7.31175 13.4 7.29831 13.4124Z",
    fill: "url(#paint58_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36678 13.3716C7.35603 13.3815 7.37126 13.3975 7.38201 13.3877C7.39276 13.3769 7.37753 13.3609 7.36678 13.3716Z",
    fill: "url(#paint59_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35442 13.3983C7.34276 13.41 7.35889 13.427 7.37054 13.4153C7.38219 13.4045 7.36606 13.3866 7.35442 13.3983Z",
    fill: "url(#paint60_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3365 13.428C7.32396 13.4406 7.34187 13.4594 7.35441 13.4468C7.36696 13.4351 7.34992 13.4154 7.3365 13.428Z",
    fill: "url(#paint61_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3983 13.3917C7.39026 13.4007 7.40369 13.4133 7.41174 13.4044C7.41982 13.3954 7.40727 13.3819 7.3983 13.3917Z",
    fill: "url(#paint62_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38859 13.4165C7.37963 13.4263 7.39396 13.4396 7.40382 13.4298C7.41187 13.4199 7.39843 13.4066 7.38859 13.4165Z",
    fill: "url(#paint63_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37532 13.4421C7.36548 13.4529 7.3816 13.4671 7.39146 13.4565C7.4013 13.4457 7.38518 13.4304 7.37532 13.4421Z",
    fill: "url(#paint64_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00101 12.0966C6.95443 12.0966 6.95443 12.1666 7.00101 12.1666C7.04759 12.1666 7.04849 12.0966 7.00101 12.0966Z",
    fill: "url(#paint65_radial_5819_33118)",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16873 12.0327C7.2207 11.8598 7.24668 11.6376 7.17322 11.3484C7.49662 11.1397 7.72416 10.9489 8.25096 10.9489C8.77684 10.9489 9.02497 11.0938 9.3287 11.3484C9.25614 11.6376 9.28212 11.8589 9.33318 12.0327H7.16699",
    fill: "#89C5E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16873 12.0327C7.2207 11.8598 7.24668 11.6376 7.17322 11.3484C7.49662 11.1397 7.72416 10.9489 8.25096 10.9489C8.77684 10.9489 9.02497 11.0938 9.3287 11.3484C9.25614 11.6376 9.28212 11.8589 9.33318 12.0327H7.16699",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41489 11.6117L7.39081 11.8732C7.39057 11.8732 7.39032 11.8731 7.39009 11.8732L7.29724 11.614L7.34194 11.8877C7.34161 11.8879 7.34126 11.888 7.34093 11.8881L7.23724 11.7513L7.29954 11.914L7.2234 11.8609L7.26969 11.9477C7.26927 11.9483 7.2688 11.9489 7.26839 11.9495L7.21417 11.9428L7.24777 11.99C7.24078 12.0095 7.23722 12.03 7.23725 12.0508C7.23725 12.0517 7.23752 12.0527 7.23754 12.0536H7.59574C7.59576 12.0527 7.59603 12.0517 7.59603 12.0507C7.59603 12.0294 7.59238 12.0088 7.58551 11.9897L7.65607 11.9221L7.56724 11.9531C7.56652 11.952 7.56581 11.9508 7.56507 11.9497C7.57872 11.933 7.71231 11.7686 7.70683 11.7686C7.70116 11.7686 7.53793 11.9086 7.53219 11.9135L7.53132 11.9128L7.65952 11.629L7.48215 11.8837C7.48157 11.8835 7.481 11.8832 7.48042 11.883L7.53265 11.614L7.43921 11.8725L7.41498 11.6117L7.41489 11.6117Z",
    fill: "#FCDD09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16718 12.0327C7.13851 12.1286 7.10269 12.2102 7.07134 12.28C6.98981 12.4637 6.97279 12.8909 7.2738 13.193C7.72083 13.64 8.06128 13.4599 8.23239 13.7035H8.26732C8.43843 13.4599 8.77885 13.64 9.22591 13.193C9.52692 12.8909 9.5108 12.4637 9.42837 12.28C9.39791 12.2109 9.36117 12.1286 9.33251 12.0327H7.16632",
    fill: "#0F47AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16718 12.0327C7.13851 12.1286 7.10269 12.2102 7.07134 12.28C6.98981 12.4637 6.97279 12.8909 7.2738 13.193C7.72083 13.64 8.06128 13.4599 8.23239 13.7035H8.26732C8.43843 13.4599 8.77885 13.64 9.22591 13.193C9.52692 12.8909 9.5108 12.4637 9.42837 12.28C9.39791 12.2109 9.36117 12.1286 9.33251 12.0327H7.16632",
    stroke: "black",
    strokeWidth: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82153 11.6215C7.81635 11.5965 7.75787 11.6013 7.76211 11.561C7.72322 11.5548 7.73047 11.4853 7.80307 11.49C7.81071 11.4762 7.89847 11.4446 7.88786 11.4883C7.9319 11.4499 7.9638 11.4851 7.9392 11.5021C7.95619 11.5191 7.96476 11.558 7.91266 11.5546C7.9326 11.5901 7.88631 11.5888 7.85556 11.5789C7.85632 11.5923 7.85403 11.6029 7.83652 11.5996C7.82548 11.6071 7.83384 11.6167 7.83537 11.6256L7.82153 11.6215ZM8.62724 11.6489C8.62773 11.6173 8.56812 11.6269 8.57034 11.5909C8.53798 11.5859 8.54268 11.5189 8.60956 11.523C8.60583 11.5036 8.69961 11.4788 8.69076 11.5213C8.72343 11.4867 8.75567 11.519 8.73589 11.5346C8.75216 11.5508 8.77191 11.5789 8.71452 11.5848C8.73765 11.6073 8.68927 11.6175 8.65983 11.608C8.66055 11.6209 8.65202 11.6253 8.63525 11.6221C8.62467 11.6293 8.63903 11.6443 8.64049 11.6528L8.62724 11.6489ZM9.09183 11.7582C9.09738 11.7343 9.04266 11.7364 9.04408 11.7091C9.01922 11.7054 9.02283 11.6546 9.07421 11.6577C9.07135 11.643 9.13821 11.6184 9.13372 11.6541C9.15882 11.6279 9.18647 11.6547 9.17128 11.6664C9.18378 11.6788 9.19896 11.7 9.15485 11.7045C9.17263 11.7215 9.13546 11.7293 9.11284 11.7221C9.11339 11.7318 9.1103 11.7334 9.09742 11.731C9.08929 11.7365 9.10724 11.7495 9.10836 11.756L9.09183 11.7582V11.7582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90521 12.2146C8.91867 12.1447 8.97612 12.0802 8.98241 12.0256C8.98779 11.9763 8.99767 11.9557 9.02639 11.9038C9.05511 11.8518 9.06676 11.8277 9.07306 11.7917C9.08202 11.7451 9.11704 11.7353 9.13318 11.7828C9.14844 11.8302 9.17895 11.9495 9.19511 11.9772C9.21036 12.005 9.22655 12.0435 9.22383 12.0623C9.22114 12.0811 9.24449 12.0882 9.25795 12.1018C9.27142 12.1144 9.27321 12.1582 9.3127 12.1958C9.35218 12.2334 9.39616 12.2602 9.43296 12.279C9.46617 12.3536 9.48861 12.4664 9.48322 12.5953H7.01772C7.01682 12.5614 7.01772 12.5281 7.01951 12.496C7.2385 12.4396 7.32018 12.2953 7.41262 12.3052C7.46289 12.2352 7.52392 12.16 7.5661 12.1215C7.61635 12.0758 7.71508 11.894 7.74022 11.7828C7.76536 11.6727 7.80214 11.6135 7.82997 11.6197C7.85779 11.6261 7.86946 11.6314 7.90266 11.7309C7.94846 11.8678 7.97987 11.8841 8.01486 11.9825C8.04537 12.0678 8.10911 12.2208 8.20694 12.3006C8.26797 12.255 8.33798 12.2038 8.36041 12.168C8.37927 12.1366 8.40799 12.0882 8.44209 12.0651C8.45735 12.0194 8.47708 11.9378 8.49326 11.9181C8.50851 11.9002 8.51479 11.8823 8.51658 11.8509C8.51747 11.8194 8.54171 11.7532 8.57492 11.6977C8.60814 11.6431 8.65212 11.6252 8.67186 11.6977C8.6907 11.7704 8.73468 11.9227 8.77597 12.0176C8.79302 12.057 8.82445 12.1348 8.89354 12.2164L8.901 12.2252C8.9024 12.2228 8.90381 12.221 8.90521 12.2146V12.2146Z",
    fill: "#509164",
    stroke: "black",
    strokeWidth: 0.07992
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62255 12.4725C8.57677 12.4285 8.50408 12.4383 8.46729 12.4035C8.43138 12.3695 8.37393 12.3927 8.25006 12.3301C8.2348 12.3221 8.21955 12.3122 8.20429 12.3005C8.10646 12.2207 8.04274 12.0675 8.01223 11.9824C7.97811 11.8847 7.94581 11.8687 7.90003 11.7306C7.8758 11.6572 7.86233 11.6347 7.84618 11.6267C7.88837 11.6726 7.86594 11.7441 7.90003 11.8212C7.9135 11.8517 7.89105 11.8517 7.88388 11.8418C7.87761 11.832 7.85696 11.8274 7.84708 11.8283C7.86504 11.8437 7.86773 11.8822 7.88567 11.9223C7.90272 11.9627 7.87221 11.9583 7.90902 12.0157C7.91887 12.0317 7.92248 12.0558 7.90812 12.0657C7.89287 12.0746 7.88209 12.0379 7.85964 12.0505C7.86594 12.065 7.89194 12.0909 7.90902 12.106C7.92606 12.1214 7.90991 12.1294 7.89645 12.1223C7.88209 12.115 7.86322 12.1079 7.85337 12.0998C7.85337 12.1115 7.86773 12.1248 7.88746 12.1427C7.90812 12.1599 7.89465 12.1723 7.84707 12.1723C7.85426 12.1831 7.85158 12.2099 7.83002 12.2136C7.85964 12.2154 7.88209 12.27 7.91887 12.2737C7.95479 12.2762 7.95838 12.3014 7.92338 12.3076C7.88836 12.3138 7.81746 12.2574 7.78246 12.2207C7.77348 12.2333 7.75464 12.2386 7.74117 12.2315C7.74028 12.2484 7.74565 12.2897 7.76181 12.3166C7.74476 12.3094 7.72233 12.287 7.69988 12.2592C7.67835 12.2333 7.66399 12.2718 7.68283 12.295C7.70167 12.3184 7.71424 12.3372 7.68373 12.3551C7.65411 12.3721 7.63527 12.3659 7.61283 12.3344C7.58141 12.3606 7.56885 12.3622 7.5446 12.3578C7.5446 12.373 7.51857 12.409 7.50692 12.4358C7.48089 12.4876 8.66115 12.5952 8.62795 12.4698",
    fill: "#034418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4714 12.4805C9.16084 12.4534 8.98943 12.3335 8.89248 12.2188C8.82337 12.1381 8.79196 12.0594 8.77491 12.0199C8.73362 11.925 8.68964 11.7727 8.6708 11.7C8.6645 11.6759 8.65554 11.6615 8.64477 11.6562C8.62861 11.6482 8.63668 11.6759 8.64835 11.6902C8.66092 11.7037 8.66002 11.7163 8.64387 11.7064C8.62772 11.6975 8.61963 11.7154 8.63489 11.7376C8.64925 11.7592 8.67169 11.7844 8.67617 11.8085C8.68068 11.8319 8.68247 11.8523 8.69412 11.864C8.70489 11.8757 8.6645 11.8784 8.64745 11.8507C8.64656 11.8686 8.65195 11.8945 8.6636 11.8917C8.67438 11.8899 8.67797 11.8998 8.66271 11.9268C8.64745 11.9527 8.64925 11.9617 8.65465 11.9734C8.66271 11.9913 8.68337 11.9204 8.69593 11.9608C8.70221 11.9796 8.71298 12.003 8.72284 12.0181C8.73272 12.0326 8.73182 12.0415 8.71746 12.0415C8.7031 12.0415 8.69053 12.0055 8.68874 12.036C8.68785 12.0656 8.71119 12.0754 8.73541 12.0736C8.75875 12.0727 8.76234 12.0816 8.75875 12.0943C8.75606 12.1069 8.76592 12.1192 8.77939 12.1167C8.79195 12.1131 8.81171 12.1248 8.82247 12.1553C8.83324 12.1858 8.8153 12.1991 8.78927 12.1775C8.76323 12.1553 8.72555 12.1355 8.72194 12.1192C8.71925 12.105 8.70848 12.1257 8.72015 12.1454C8.73092 12.1651 8.7372 12.1741 8.75156 12.1821C8.76592 12.1892 8.75067 12.2188 8.72645 12.2C8.7031 12.1821 8.69233 12.1864 8.68516 12.2071C8.67348 12.2403 8.63849 12.2323 8.64925 12.2502C8.66002 12.2681 8.65554 12.2968 8.63938 12.3039C8.62232 12.311 8.60258 12.3004 8.60437 12.269C8.59989 12.2752 8.58284 12.278 8.56938 12.2743C8.56759 12.3183 8.55502 12.3335 8.52809 12.3218C8.52719 12.3316 8.52629 12.3486 8.51283 12.3612C8.54245 12.3568 8.54872 12.3773 8.55141 12.3899C8.55323 12.4025 8.55771 12.4007 8.57476 12.4025C8.59091 12.4034 8.61156 12.4247 8.58105 12.4195C8.55051 12.4151 8.50295 12.4256 8.47513 12.4052C8.50385 12.4312 8.58553 12.4321 8.61963 12.4651C8.86826 12.5674 9.30627 12.6032 9.47945 12.5557C9.48035 12.535 9.47766 12.4876 9.47587 12.4724",
    fill: "#034418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11087 11.7544C9.11804 11.7579 9.12523 11.7677 9.13151 11.7831C9.14676 11.8306 9.17727 11.9496 9.19345 11.9774C9.20871 12.0051 9.22486 12.0436 9.22217 12.0624C9.21946 12.0812 9.24281 12.0886 9.25627 12.1019C9.26974 12.1145 9.27153 12.1583 9.31102 12.1959C9.35052 12.2335 9.3945 12.2606 9.43128 12.2794C9.45373 12.3294 9.47078 12.3966 9.47795 12.4755C9.37205 12.4675 9.23922 12.436 9.17279 12.4065C9.17548 12.3966 9.17548 12.3842 9.1719 12.3654C9.16742 12.3466 9.171 12.3321 9.19074 12.3143C9.2105 12.2964 9.2042 12.2659 9.19345 12.2489C9.18267 12.2328 9.18357 12.223 9.19253 12.2131C9.20062 12.2042 9.20062 12.1879 9.18178 12.17C9.16202 12.1521 9.17548 12.1333 9.18625 12.1173C9.19703 12.101 9.21319 12.0732 9.20151 12.0374C9.18984 12.0026 9.1719 12.0455 9.15754 12.0322C9.14855 12.023 9.14318 12.006 9.15306 11.9918C9.16291 11.9783 9.15664 11.9524 9.14497 11.9326C9.171 11.9255 9.12703 11.8494 9.11983 11.8171C9.11267 11.7847 9.12792 11.7687 9.11087 11.756",
    fill: "#034418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98164 12.0453C7.98164 12.0623 7.97716 12.0866 7.97266 12.0946C7.98343 12.1116 7.99779 12.1465 7.996 12.1572C8.01036 12.1439 8.03818 12.1545 8.04446 12.1914C8.05075 12.229 8.05703 12.2639 8.05344 12.2845C8.06601 12.2953 8.09294 12.3141 8.09742 12.3348C8.1019 12.3545 8.11537 12.3517 8.12883 12.3499C8.17101 12.3437 8.16743 12.3946 8.21141 12.3875C8.27333 12.3786 8.23476 12.4279 8.29668 12.426C8.33257 12.4242 8.38194 12.4313 8.40708 12.4664C8.43488 12.4288 8.45912 12.443 8.48426 12.4529C8.50939 12.4618 8.5408 12.4593 8.51298 12.4396C8.48426 12.4189 8.42771 12.4162 8.40258 12.4224C8.37744 12.4288 8.33976 12.4242 8.31372 12.401C8.28859 12.3776 8.24461 12.3579 8.21768 12.357C8.19075 12.3561 8.18448 12.3545 8.16385 12.324C8.14409 12.2944 8.11178 12.2978 8.09563 12.2962C8.08037 12.2953 8.0687 12.2756 8.08665 12.2568C8.11268 12.229 8.07587 12.2254 8.08933 12.2084C8.1028 12.1914 8.09563 12.1689 8.05972 12.1662C8.02383 12.1634 8.03729 12.152 8.04267 12.1267C8.05523 12.0669 7.97445 12.0767 7.98074 12.0481L7.98164 12.0453ZM9.39079 12.3678C9.39437 12.3311 9.36655 12.316 9.36028 12.288C9.3549 12.2602 9.3109 12.2593 9.29925 12.2676C9.30373 12.2756 9.29925 12.2898 9.29385 12.2978C9.28847 12.3052 9.28847 12.3095 9.29925 12.3132C9.3109 12.316 9.32078 12.3185 9.32167 12.3284C9.32257 12.3373 9.32797 12.3293 9.33245 12.3176C9.33604 12.3061 9.36745 12.332 9.37105 12.3552C9.37374 12.3786 9.38631 12.3946 9.38989 12.3669L9.39079 12.3678ZM9.24539 12.3283C9.25077 12.3419 9.27053 12.3607 9.28128 12.3607C9.29205 12.3607 9.30821 12.3687 9.31089 12.3813C9.31271 12.3921 9.32167 12.4072 9.33334 12.4091C9.34502 12.4109 9.33872 12.4198 9.32436 12.4189C9.3091 12.418 9.28578 12.4091 9.28399 12.3983C9.28937 12.4208 9.28217 12.4306 9.26781 12.4143C9.25435 12.3992 9.24719 12.3776 9.22923 12.3749C9.2427 12.3724 9.24449 12.3687 9.2382 12.3552C9.23282 12.3419 9.2373 12.3061 9.24539 12.3283Z",
    fill: "#509164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.01985 12.5533C7.04936 12.5389 7.09489 12.5444 7.11187 12.5595C7.12079 12.5425 7.1351 12.5299 7.16193 12.5345C7.1834 12.5111 7.20128 12.4994 7.2138 12.5111C7.22632 12.4879 7.26835 12.4824 7.28266 12.4969C7.29786 12.4735 7.32826 12.4627 7.34881 12.4753C7.37564 12.4402 7.42303 12.4279 7.45164 12.4457C7.47668 12.4269 7.5053 12.4306 7.51781 12.443C7.53033 12.4547 7.55716 12.4306 7.5679 12.4529C7.58667 12.4485 7.62242 12.4476 7.62959 12.4673C7.63405 12.4565 7.65014 12.4501 7.65909 12.4584C7.65909 12.4171 7.6886 12.3857 7.72974 12.3955C7.7494 12.3659 7.78339 12.3535 7.79949 12.3641C7.81647 12.3471 7.85134 12.3588 7.86653 12.3795C7.89963 12.3785 7.91572 12.3937 7.93271 12.4233C7.94969 12.4529 7.99888 12.4707 8.03018 12.4574C8.06147 12.4457 8.09009 12.4421 8.10082 12.4565C8.11959 12.4396 8.14017 12.4439 8.15267 12.4556C8.17414 12.4744 8.19469 12.4412 8.20722 12.4538C8.2269 12.4744 8.24478 12.435 8.27965 12.4556C8.31364 12.4762 8.38069 12.5074 8.43256 12.5074C8.48443 12.5074 8.52556 12.4439 8.55864 12.4886C8.59172 12.4664 8.6418 12.4556 8.67667 12.4744C8.69724 12.4556 8.74463 12.4494 8.7634 12.4673C8.78217 12.4386 8.81795 12.4214 8.84834 12.4313C8.86533 12.4019 8.93329 12.3974 8.95385 12.4386C8.97086 12.4386 8.99766 12.4538 8.99766 12.4726C9.01467 12.4726 9.0415 12.4834 9.0415 12.5031C9.06027 12.4985 9.0835 12.5102 9.0871 12.5327C9.12464 12.5299 9.15506 12.5453 9.17204 12.5765C9.18456 12.5657 9.1774 12.5379 9.20601 12.5327C9.23463 12.5281 9.24358 12.537 9.25161 12.5469C9.2829 12.5237 9.32674 12.5265 9.36338 12.5595C9.39021 12.5487 9.41526 12.5533 9.42329 12.5666C9.43492 12.5558 9.45369 12.5533 9.47248 12.5533C9.47338 12.6141 9.468 12.6804 9.45459 12.7485H7.03319C7.02067 12.6822 7.01532 12.6159 7.01621 12.5549",
    fill: "#078930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.01985 12.5533C7.04936 12.5389 7.09489 12.5444 7.11187 12.5595C7.12079 12.5425 7.1351 12.5299 7.16193 12.5345C7.1834 12.5111 7.20128 12.4994 7.2138 12.5111C7.22632 12.4879 7.26835 12.4824 7.28266 12.4969C7.29786 12.4735 7.32826 12.4627 7.34881 12.4753C7.37564 12.4402 7.42303 12.4279 7.45164 12.4457C7.47668 12.4269 7.5053 12.4306 7.51781 12.443C7.53033 12.4547 7.55716 12.4306 7.5679 12.4529C7.58667 12.4485 7.62242 12.4476 7.62959 12.4673C7.63405 12.4565 7.65014 12.4501 7.65909 12.4584C7.65909 12.4171 7.6886 12.3857 7.72974 12.3955C7.7494 12.3659 7.78339 12.3535 7.79949 12.3641C7.81647 12.3471 7.85134 12.3588 7.86653 12.3795C7.89963 12.3785 7.91572 12.3937 7.93271 12.4233C7.94969 12.4529 7.99888 12.4707 8.03018 12.4574C8.06147 12.4457 8.09009 12.4421 8.10082 12.4565C8.11959 12.4396 8.14017 12.4439 8.15267 12.4556C8.17414 12.4744 8.19469 12.4412 8.20722 12.4538C8.2269 12.4744 8.24478 12.435 8.27965 12.4556C8.31364 12.4762 8.38069 12.5074 8.43256 12.5074C8.48443 12.5074 8.52556 12.4439 8.55864 12.4886C8.59172 12.4664 8.6418 12.4556 8.67667 12.4744C8.69724 12.4556 8.74463 12.4494 8.7634 12.4673C8.78217 12.4386 8.81795 12.4214 8.84834 12.4313C8.86533 12.4019 8.93329 12.3974 8.95385 12.4386C8.97086 12.4386 8.99766 12.4538 8.99766 12.4726C9.01467 12.4726 9.0415 12.4834 9.0415 12.5031C9.06027 12.4985 9.0835 12.5102 9.0871 12.5327C9.12464 12.5299 9.15506 12.5453 9.17204 12.5765C9.18456 12.5657 9.1774 12.5379 9.20601 12.5327C9.23463 12.5281 9.24358 12.537 9.25161 12.5469C9.2829 12.5237 9.32674 12.5265 9.36338 12.5595C9.39021 12.5487 9.41526 12.5533 9.42329 12.5666C9.43492 12.5558 9.45369 12.5533 9.47248 12.5533C9.47338 12.6141 9.468 12.6804 9.45459 12.7485H7.03319C7.02067 12.6822 7.01532 12.6159 7.01621 12.5549",
    stroke: "black",
    strokeWidth: 0.07992
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24913 11.165L8.22493 11.243H8.14253L8.2097 11.2914L8.18461 11.3693L8.25002 11.321L8.31632 11.3693L8.29123 11.2914L8.35751 11.2448H8.276L8.25091 11.1668L8.24913 11.165ZM7.93736 11.1909L7.92571 11.2717L7.8451 11.2843L7.91856 11.321L7.90601 11.4015L7.96335 11.3432L8.03592 11.3801L7.99828 11.3074L8.05652 11.2501L7.9759 11.2627L7.93827 11.19L7.93736 11.1909ZM7.6328 11.2671L7.6337 11.3487L7.55574 11.3746L7.63459 11.3989V11.4804L7.68117 11.4132L7.75913 11.4375L7.70984 11.3719L7.75734 11.3056L7.67939 11.3317L7.63012 11.2662L7.6328 11.2671ZM7.34522 11.3916L7.35955 11.4723L7.28699 11.5108L7.36849 11.5216L7.38194 11.6021L7.41689 11.5287L7.4975 11.5395L7.43838 11.4822L7.47422 11.4095L7.40166 11.448L7.34254 11.3916L7.34522 11.3916ZM8.56269 11.1909L8.57434 11.2717L8.65495 11.2843L8.58149 11.321L8.59404 11.4015L8.5367 11.3432L8.46413 11.3801L8.50174 11.3074L8.44442 11.2501L8.52505 11.2627L8.56268 11.19L8.56269 11.1909ZM8.8673 11.2671L8.8664 11.3487L8.94433 11.3746L8.86551 11.3989V11.4804L8.81893 11.4132L8.74097 11.4375L8.79026 11.3719L8.74276 11.3056L8.81982 11.3317L8.86908 11.2662L8.8673 11.2671ZM9.15488 11.3916L9.14055 11.4723L9.21311 11.5108L9.13158 11.5216L9.11816 11.6021L9.08321 11.5287L9.00258 11.5395L9.06172 11.4822L9.02587 11.4095L9.09844 11.448L9.15756 11.3916",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11487 13.1376L8.12381 12.5384C8.12381 12.5097 8.1292 12.5051 8.1301 12.5366L8.13189 13.1441",
    fill: "#865800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11487 13.1376L8.12381 12.5384C8.12381 12.5097 8.1292 12.5051 8.1301 12.5366L8.13189 13.1441",
    fill: "#704D25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11487 13.1376L8.12381 12.5384C8.12381 12.5097 8.1292 12.5051 8.1301 12.5366L8.13189 13.1441",
    stroke: "black",
    strokeWidth: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13098 12.5375C8.15158 12.5196 8.19905 12.56 8.22861 12.543C8.2107 12.601 8.13903 12.5554 8.13098 12.5769V12.5375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13098 12.5375C8.15158 12.5196 8.19905 12.56 8.22861 12.543C8.2107 12.601 8.13903 12.5554 8.13098 12.5769V12.5375Z",
    stroke: "black",
    strokeWidth: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31729 13.1386L8.32623 12.5402C8.32623 12.5116 8.33162 12.5061 8.33252 12.5393L8.33431 13.1457",
    fill: "#865800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31729 13.1386L8.32623 12.5402C8.32623 12.5116 8.33162 12.5061 8.33252 12.5393L8.33431 13.1457",
    fill: "#704D25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31729 13.1386L8.32623 12.5402C8.32623 12.5116 8.33162 12.5061 8.33252 12.5393L8.33431 13.1457",
    stroke: "black",
    strokeWidth: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33435 12.5393C8.35495 12.5214 8.40244 12.5618 8.432 12.5446C8.41318 12.6028 8.3424 12.5572 8.33435 12.5788V12.5393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33435 12.5393C8.35495 12.5214 8.40244 12.5618 8.432 12.5446C8.41318 12.6028 8.3424 12.5572 8.33435 12.5788V12.5393Z",
    stroke: "black",
    strokeWidth: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.509 13.1719L8.51797 12.5724C8.51797 12.5437 8.52334 12.5393 8.52423 12.5717L8.52602 13.178",
    fill: "#865800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.509 13.1719L8.51797 12.5724C8.51797 12.5437 8.52334 12.5393 8.52423 12.5717L8.52602 13.178",
    fill: "#704D25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.509 13.1719L8.51797 12.5724C8.51797 12.5437 8.52334 12.5393 8.52423 12.5717L8.52602 13.178",
    stroke: "black",
    strokeWidth: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52518 12.5724C8.5458 12.5545 8.59327 12.5948 8.62283 12.5769C8.60403 12.6352 8.53325 12.5896 8.52518 12.6109V12.5717",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52518 12.5724C8.5458 12.5545 8.59327 12.5948 8.62283 12.5769C8.60403 12.6352 8.53325 12.5896 8.52518 12.6109V12.5717V12.5724Z",
    stroke: "black",
    strokeWidth: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57802 13.2407C8.55741 13.2407 8.53144 13.231 8.52426 13.2147C8.50904 13.2292 8.44544 13.2372 8.42035 13.2157C8.40333 13.2301 8.35047 13.24 8.32359 13.2228C8.3021 13.2416 8.23849 13.24 8.20535 13.2202C8.19191 13.2345 8.15338 13.2452 8.13278 13.2471C8.10322 13.2049 8.02347 13.1377 7.97332 13.1127C7.91688 13.0849 7.804 13.031 7.74397 13.0051C7.70903 12.99 7.67678 12.9638 7.74308 12.9925C7.81386 13.023 7.92763 13.0686 8.00467 13.1028C8.11487 13.1512 8.55473 13.1441 8.62727 13.1377C8.66491 13.1352 8.71506 13.1065 8.75002 13.0849C8.7769 13.0686 8.77779 13.0785 8.75181 13.092C8.72314 13.1072 8.69179 13.1189 8.66938 13.1503C8.63892 13.1925 8.59682 13.2113 8.58069 13.239",
    fill: "#704D25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57802 13.2407C8.55741 13.2407 8.53144 13.231 8.52426 13.2147C8.50904 13.2292 8.44544 13.2372 8.42035 13.2157C8.40333 13.2301 8.35047 13.24 8.32359 13.2228C8.3021 13.2416 8.23849 13.24 8.20535 13.2202C8.19191 13.2345 8.15338 13.2452 8.13278 13.2471C8.10322 13.2049 8.02347 13.1377 7.97332 13.1127C7.91688 13.0849 7.804 13.031 7.74397 13.0051C7.70903 12.99 7.67678 12.9638 7.74308 12.9925C7.81386 13.023 7.92763 13.0686 8.00467 13.1028C8.11487 13.1512 8.55473 13.1441 8.62727 13.1377C8.66491 13.1352 8.71506 13.1065 8.75002 13.0849C8.7769 13.0686 8.77779 13.0785 8.75181 13.092C8.72314 13.1072 8.69179 13.1189 8.66938 13.1503C8.63892 13.1925 8.59682 13.2113 8.58069 13.239L8.57801 13.2407H8.57802Z",
    fill: "#704D25",
    stroke: "black",
    strokeWidth: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6192 12.6746L8.47676 12.6592C8.45167 12.7014 8.44809 12.7542 8.46153 12.7911C8.50721 12.748 8.58964 12.7705 8.63085 12.7927C8.61741 12.7551 8.5968 12.7042 8.6201 12.6755",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6192 12.6746L8.47676 12.6592C8.45167 12.7014 8.44809 12.7542 8.46153 12.7911C8.50721 12.748 8.58964 12.7705 8.63085 12.7927C8.61741 12.7551 8.5968 12.7042 8.6201 12.6755L8.6192 12.6746V12.6746Z",
    stroke: "black",
    strokeWidth: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62994 12.7918C8.58785 12.7927 8.48752 12.7902 8.45614 12.7902C8.42211 12.834 8.44092 12.9003 8.44899 12.9255C8.4866 12.8654 8.60576 12.8975 8.65145 12.9407C8.62814 12.8966 8.61024 12.859 8.63085 12.7911",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62994 12.7918C8.58785 12.7927 8.48752 12.7902 8.45614 12.7902C8.42211 12.834 8.44092 12.9003 8.44899 12.9255C8.4866 12.8654 8.60576 12.8975 8.65145 12.9407C8.62814 12.8966 8.61024 12.859 8.63085 12.7911L8.62994 12.7918Z",
    stroke: "black",
    strokeWidth: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65056 12.9425C8.60935 12.9352 8.47677 12.9262 8.44989 12.9191C8.42838 12.9638 8.41047 13.0221 8.40152 13.0778C8.46601 13.007 8.61563 13.059 8.64698 13.1278C8.61563 13.0686 8.58426 12.9792 8.65146 12.9425",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65056 12.9425C8.60935 12.9352 8.47677 12.9262 8.44989 12.9191C8.42838 12.9638 8.41047 13.0221 8.40152 13.0778C8.46601 13.007 8.61563 13.059 8.64698 13.1278C8.61563 13.0686 8.58426 12.9792 8.65146 12.9425H8.65056H8.65056Z",
    stroke: "black",
    strokeWidth: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4732 12.6315L8.28504 12.6065C8.25819 12.6379 8.23846 12.6934 8.24115 12.7579C8.28057 12.7203 8.42481 12.7354 8.46154 12.7893C8.449 12.731 8.43288 12.6577 8.47409 12.6306",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4732 12.6315L8.28504 12.6065C8.25819 12.6379 8.23846 12.6934 8.24115 12.7579C8.28057 12.7203 8.42481 12.7354 8.46154 12.7893C8.449 12.731 8.43288 12.6577 8.47409 12.6306L8.4732 12.6315V12.6315Z",
    stroke: "black",
    strokeWidth: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45887 12.7946L8.25012 12.7668C8.21698 12.809 8.21877 12.8689 8.22682 12.9327C8.27432 12.8932 8.42928 12.9148 8.46602 12.9675C8.44364 12.8905 8.42481 12.8448 8.45976 12.7946",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45887 12.7946L8.25012 12.7668C8.21698 12.809 8.21877 12.8689 8.22682 12.9327C8.27432 12.8932 8.42928 12.9148 8.46602 12.9675C8.44364 12.8905 8.42481 12.8448 8.45976 12.7946H8.45887V12.7946Z",
    stroke: "black",
    strokeWidth: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4651 12.9675L8.25278 12.946C8.21963 12.9872 8.19723 13.0294 8.20441 13.0911C8.23754 13.0366 8.3782 13.076 8.43822 13.1368C8.4024 13.0893 8.3988 13.0212 8.4651 12.9675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4651 12.9675L8.25278 12.946C8.21963 12.9872 8.19723 13.0294 8.20441 13.0911C8.23754 13.0366 8.3782 13.076 8.43822 13.1368C8.4024 13.0893 8.3988 13.0212 8.4651 12.9675V12.9675Z",
    stroke: "black",
    strokeWidth: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11929 12.6315C8.09599 12.6494 8.06017 12.7113 8.05478 12.7283C8.0942 12.7123 8.17752 12.7077 8.22949 12.7462C8.21426 12.7166 8.20887 12.6648 8.22231 12.6432C8.20172 12.6343 8.14707 12.6297 8.12019 12.6325",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11929 12.6315C8.09599 12.6494 8.06017 12.7113 8.05478 12.7283C8.0942 12.7123 8.17752 12.7077 8.22949 12.7462C8.21426 12.7166 8.20887 12.6648 8.22231 12.6432C8.20172 12.6343 8.14707 12.6297 8.12019 12.6325L8.1193 12.6315L8.11929 12.6315Z",
    stroke: "black",
    strokeWidth: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03241 12.7569C8.08706 12.756 8.19903 12.7696 8.24742 12.7829C8.21876 12.826 8.22233 12.8994 8.23398 12.945C8.15963 12.8716 8.03689 12.8734 7.96432 12.895C7.97776 12.8618 8.0109 12.7927 8.03152 12.756",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03241 12.7569C8.08706 12.756 8.19903 12.7696 8.24742 12.7829C8.21876 12.826 8.22233 12.8994 8.23398 12.945C8.15963 12.8716 8.03689 12.8734 7.96432 12.895C7.97776 12.8618 8.0109 12.7927 8.03152 12.756L8.03241 12.7569V12.7569Z",
    stroke: "black",
    strokeWidth: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2492 12.9613C8.19633 12.9632 8.06107 12.9398 7.99924 12.9093C7.97775 12.9675 7.96789 13.0643 7.96609 13.0992C8.02611 13.0187 8.17305 13.0634 8.21963 13.1457C8.21516 13.1019 8.19902 12.9943 8.2492 12.9604",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2492 12.9613C8.19633 12.9632 8.06107 12.9398 7.99924 12.9093C7.97775 12.9675 7.96789 13.0643 7.96609 13.0992C8.02611 13.0187 8.17305 13.0634 8.21963 13.1457C8.21516 13.1019 8.19902 12.9943 8.2492 12.9604V12.9613V12.9613Z",
    stroke: "black",
    strokeWidth: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11928 12.6315C7.97055 12.7212 7.85769 12.9021 7.81558 13.0276C7.85769 13.0267 7.91053 13.0402 7.92936 13.0778C7.97325 12.8976 8.03506 12.7311 8.11928 12.6306",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6192 12.6746C8.65234 12.8359 8.66041 13.0526 8.64698 13.1324M8.1193 12.6315C7.97057 12.7212 7.85771 12.9022 7.81561 13.0276C7.85771 13.0267 7.91055 13.0402 7.92938 13.0778C7.97328 12.8976 8.03509 12.7311 8.1193 12.6306V12.6315ZM8.12378 12.5446C8.00195 12.6673 7.82905 12.8861 7.76633 13.0051L8.12378 12.5446Z",
    stroke: "black",
    strokeWidth: 0.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79554 12.9658C8.75777 12.9847 8.68617 12.9319 8.65237 12.9559V12.935C8.68518 12.9121 8.75678 12.9648 8.79554 12.9449V12.9668",
    fill: "#00009E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79554 12.9658C8.75777 12.9847 8.68617 12.9319 8.65237 12.9559V12.935C8.68518 12.9121 8.75678 12.9648 8.79554 12.9449V12.9668V12.9658V12.9658Z",
    fill: "#002B7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79554 12.9877C8.75777 13.0065 8.68617 12.9538 8.65237 12.9767V12.9548C8.68518 12.9319 8.75678 12.9846 8.79554 12.9648V12.9867",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79554 13.0096C8.75777 13.0295 8.68617 12.9767 8.65237 12.9997V12.9778C8.68518 12.9549 8.75678 13.0076 8.79554 12.9887V13.0096Z",
    fill: "#FF0016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79554 13.0096C8.75777 13.0295 8.68617 12.9767 8.65237 12.9997V12.9778C8.68518 12.9549 8.75678 13.0076 8.79554 12.9887V13.0096Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79554 13.0315C8.75777 13.0513 8.68617 12.9986 8.65237 13.0215V12.9996C8.68518 12.9777 8.75678 13.0294 8.79554 13.0096V13.0315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79554 13.0524C8.75777 13.0722 8.68617 13.0195 8.65237 13.0424V13.0205C8.68518 12.9976 8.75678 13.0503 8.79554 13.0305V13.0514",
    fill: "#00009E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79554 13.0524C8.75777 13.0722 8.68617 13.0195 8.65237 13.0424V13.0205C8.68518 12.9976 8.75678 13.0503 8.79554 13.0305V13.0524V13.0524Z",
    fill: "#002B7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19281 12.0653L8.19598 11.8527C8.19598 11.8425 8.1979 11.8409 8.19821 11.852L8.19885 12.0676",
    fill: "#865800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19281 12.0653L8.19598 11.8527C8.19598 11.8425 8.1979 11.8409 8.19821 11.852L8.19885 12.0676",
    fill: "#704D25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19281 12.0653L8.19598 11.8527C8.19598 11.8425 8.1979 11.8409 8.19821 11.852L8.19885 12.0676",
    stroke: "black",
    strokeWidth: 0.0520068,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19858 11.8523C8.20589 11.846 8.22274 11.8603 8.23322 11.8543C8.22687 11.8749 8.20144 11.8587 8.19858 11.8663V11.8523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19858 11.8523C8.20589 11.846 8.22274 11.8603 8.23322 11.8543C8.22687 11.8749 8.20144 11.8587 8.19858 11.8663V11.8523Z",
    stroke: "black",
    strokeWidth: 0.0520068,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26465 12.0656L8.26782 11.8533C8.26782 11.8431 8.26974 11.8412 8.27005 11.853L8.27069 12.0682",
    fill: "#865800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26465 12.0656L8.26782 11.8533C8.26782 11.8431 8.26974 11.8412 8.27005 11.853L8.27069 12.0682",
    fill: "#704D25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26465 12.0656L8.26782 11.8533C8.26782 11.8431 8.26974 11.8412 8.27005 11.853L8.27069 12.0682",
    stroke: "black",
    strokeWidth: 0.0520068,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27072 11.853C8.27803 11.8466 8.29489 11.861 8.30538 11.8549C8.2987 11.8755 8.27358 11.8593 8.27072 11.867V11.853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27072 11.853C8.27803 11.8466 8.29489 11.861 8.30538 11.8549C8.2987 11.8755 8.27358 11.8593 8.27072 11.867V11.853",
    stroke: "black",
    strokeWidth: 0.0520068,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33267 12.0774L8.33586 11.8647C8.33586 11.8545 8.33776 11.853 8.33808 11.8645L8.33871 12.0796",
    fill: "#865800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33267 12.0774L8.33586 11.8647C8.33586 11.8545 8.33776 11.853 8.33808 11.8645L8.33871 12.0796",
    fill: "#704D25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33267 12.0774L8.33586 11.8647C8.33586 11.8545 8.33776 11.853 8.33808 11.8645L8.33871 12.0796",
    stroke: "black",
    strokeWidth: 0.0520068,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33844 11.8647C8.34575 11.8584 8.3626 11.8727 8.3731 11.8663C8.36642 11.887 8.34131 11.8708 8.33844 11.8784V11.8645",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33844 11.8647C8.34575 11.8584 8.3626 11.8727 8.3731 11.8663C8.36642 11.887 8.34131 11.8708 8.33844 11.8784V11.8645V11.8647Z",
    stroke: "black",
    strokeWidth: 0.0520068,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35718 12.1018C8.34987 12.1018 8.34065 12.0984 8.33811 12.0926C8.33271 12.0978 8.31014 12.1006 8.30124 12.093C8.29519 12.0981 8.27644 12.1016 8.2669 12.0955C8.25927 12.1022 8.2367 12.1016 8.22494 12.0946C8.22017 12.0996 8.20649 12.1035 8.19919 12.1041C8.18869 12.0891 8.1604 12.0653 8.1426 12.0564C8.12257 12.0466 8.08252 12.0275 8.06122 12.0183C8.04882 12.0129 8.03737 12.0036 8.0609 12.0138C8.08602 12.0246 8.12639 12.0408 8.15373 12.0529C8.19283 12.0701 8.34892 12.0676 8.37466 12.0653C8.38801 12.0644 8.40581 12.0542 8.41822 12.0466C8.42775 12.0408 8.42807 12.0443 8.41885 12.0491C8.40868 12.0545 8.39755 12.0586 8.3896 12.0698C8.37879 12.0848 8.36385 12.0914 8.35813 12.1013",
    fill: "#704D25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35718 12.1018C8.34987 12.1018 8.34065 12.0984 8.33811 12.0926C8.33271 12.0978 8.31014 12.1006 8.30124 12.093C8.29519 12.0981 8.27644 12.1016 8.2669 12.0955C8.25927 12.1022 8.2367 12.1016 8.22494 12.0946C8.22017 12.0996 8.20649 12.1035 8.19919 12.1041C8.18869 12.0891 8.1604 12.0653 8.1426 12.0564C8.12257 12.0466 8.08252 12.0275 8.06122 12.0183C8.04882 12.0129 8.03737 12.0036 8.0609 12.0138C8.08602 12.0246 8.12639 12.0408 8.15373 12.0529C8.19283 12.0701 8.34892 12.0676 8.37466 12.0653C8.38801 12.0644 8.40581 12.0542 8.41822 12.0466C8.42775 12.0408 8.42807 12.0443 8.41885 12.0491C8.40868 12.0545 8.39755 12.0586 8.3896 12.0698C8.37879 12.0848 8.36385 12.0914 8.35813 12.1013L8.35718 12.1018H8.35718Z",
    fill: "#704D25",
    stroke: "black",
    strokeWidth: 0.0520068,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37176 11.901L8.32122 11.8955C8.31231 11.9105 8.31105 11.9292 8.31582 11.9423C8.33202 11.927 8.36127 11.935 8.3759 11.9429C8.37113 11.9296 8.36381 11.9115 8.37208 11.9013",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37176 11.901L8.32122 11.8955C8.31231 11.9105 8.31105 11.9292 8.31582 11.9423C8.33202 11.927 8.36127 11.935 8.3759 11.9429C8.37113 11.9296 8.36381 11.9115 8.37208 11.9013L8.37176 11.901V11.901Z",
    stroke: "black",
    strokeWidth: 0.0520068,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37565 11.9426C8.36072 11.9429 8.32511 11.942 8.31398 11.942C8.3019 11.9576 8.30858 11.9811 8.31144 11.99C8.32479 11.9687 8.36707 11.9801 8.38329 11.9954C8.37502 11.9798 8.36866 11.9664 8.37598 11.9423",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37565 11.9426C8.36072 11.9429 8.32511 11.942 8.31398 11.942C8.3019 11.9576 8.30858 11.9811 8.31144 11.99C8.32479 11.9687 8.36707 11.9801 8.38329 11.9954C8.37502 11.9798 8.36866 11.9664 8.37598 11.9423L8.37565 11.9426V11.9426Z",
    stroke: "black",
    strokeWidth: 0.0520068,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3829 11.9961C8.36828 11.9935 8.32123 11.9903 8.31169 11.9878C8.30406 12.0036 8.2977 12.0243 8.29453 12.0441C8.31741 12.0189 8.37051 12.0374 8.38164 12.0618C8.37051 12.0408 8.35937 12.0091 8.38322 11.9961",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3829 11.9961C8.36828 11.9935 8.32123 11.9903 8.31169 11.9878C8.30406 12.0036 8.2977 12.0243 8.29453 12.0441C8.31741 12.0189 8.37051 12.0374 8.38164 12.0618C8.37051 12.0408 8.35937 12.0091 8.38322 11.9961H8.3829V11.9961Z",
    stroke: "black",
    strokeWidth: 0.0520068,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31998 11.8857L8.25321 11.8768C8.24369 11.888 8.23668 11.9077 8.23764 11.9305C8.25163 11.9172 8.30281 11.9226 8.31585 11.9417C8.31139 11.921 8.30567 11.895 8.3203 11.8854",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31998 11.8857L8.25321 11.8768C8.24369 11.888 8.23668 11.9077 8.23764 11.9305C8.25163 11.9172 8.30281 11.9226 8.31585 11.9417C8.31139 11.921 8.30567 11.895 8.3203 11.8854L8.31998 11.8857V11.8857Z",
    stroke: "black",
    strokeWidth: 0.0520068,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31493 11.9436L8.24085 11.9337C8.22909 11.9487 8.22973 11.9699 8.23258 11.9926C8.24944 11.9786 8.30443 11.9862 8.31746 12.0049C8.30952 11.9776 8.30284 11.9614 8.31524 11.9436",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31493 11.9436L8.24085 11.9337C8.22909 11.9487 8.22973 11.9699 8.23258 11.9926C8.24944 11.9786 8.30443 11.9862 8.31746 12.0049C8.30952 11.9776 8.30284 11.9614 8.31524 11.9436H8.31493V11.9436Z",
    stroke: "black",
    strokeWidth: 0.0520068,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31711 12.0049L8.24176 11.9973C8.23 12.0119 8.22205 12.0269 8.2246 12.0488C8.23636 12.0294 8.28627 12.0434 8.30757 12.065C8.29486 12.0481 8.29358 12.024 8.31711 12.0049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31711 12.0049L8.24176 11.9973C8.23 12.0119 8.22205 12.0269 8.2246 12.0488C8.23636 12.0294 8.28627 12.0434 8.30757 12.065C8.29486 12.0481 8.29358 12.024 8.31711 12.0049Z",
    stroke: "black",
    strokeWidth: 0.0520068,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1944 11.8857C8.18613 11.8921 8.17342 11.914 8.17151 11.9201C8.1855 11.9144 8.21506 11.9127 8.23351 11.9264C8.2281 11.9159 8.22619 11.8975 8.23096 11.8899C8.22365 11.8867 8.20426 11.8851 8.19472 11.886",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1944 11.8857C8.18613 11.8921 8.17342 11.914 8.17151 11.9201C8.1855 11.9144 8.21506 11.9127 8.23351 11.9264C8.2281 11.9159 8.22619 11.8975 8.23096 11.8899C8.22365 11.8867 8.20426 11.8851 8.19472 11.886L8.1944 11.8857Z",
    stroke: "black",
    strokeWidth: 0.0520068,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16357 11.9302C8.18296 11.9299 8.22269 11.9347 8.23986 11.9394C8.22969 11.9547 8.23096 11.9807 8.23509 11.9969C8.20871 11.9709 8.16515 11.9716 8.1394 11.9792C8.14417 11.9674 8.15593 11.9429 8.16325 11.9299",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16357 11.9302C8.18296 11.9299 8.22269 11.9347 8.23986 11.9394C8.22969 11.9547 8.23096 11.9807 8.23509 11.9969C8.20871 11.9709 8.16515 11.9716 8.1394 11.9792C8.14417 11.9674 8.15593 11.9429 8.16325 11.9299L8.16357 11.9302V11.9302Z",
    stroke: "black",
    strokeWidth: 0.0520068,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24047 12.0027C8.22171 12.0034 8.17371 11.9951 8.15177 11.9843C8.14415 12.0049 8.14065 12.0393 8.14001 12.0516C8.16131 12.0231 8.21345 12.0389 8.22998 12.0682C8.22839 12.0526 8.22267 12.0144 8.24047 12.0024",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24047 12.0027C8.22171 12.0034 8.17371 11.9951 8.15177 11.9843C8.14415 12.0049 8.14065 12.0393 8.14001 12.0516C8.16131 12.0231 8.21345 12.0389 8.22998 12.0682C8.22839 12.0526 8.22267 12.0144 8.24047 12.0024V12.0027V12.0027Z",
    stroke: "black",
    strokeWidth: 0.0520068,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19444 11.8857C8.14166 11.9175 8.10161 11.9817 8.08667 12.0263C8.10161 12.0259 8.12036 12.0307 8.12705 12.0441C8.14262 11.9801 8.16455 11.921 8.19444 11.8854",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37183 11.901C8.38359 11.9582 8.38646 12.0351 8.38169 12.0634M8.19444 11.8857C8.14166 11.9175 8.10161 11.9817 8.08667 12.0262C8.10161 12.0259 8.12036 12.0307 8.12705 12.0441C8.14262 11.9801 8.16455 11.921 8.19444 11.8854V11.8857V11.8857ZM8.19603 11.8548C8.1528 11.8984 8.09144 11.976 8.06918 12.0183L8.19603 11.8548Z",
    stroke: "black",
    strokeWidth: 0.0520068,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43438 12.0043C8.42098 12.011 8.39557 11.9923 8.38358 12.0008V11.9934C8.39522 11.9853 8.42063 12.004 8.43438 11.9969V12.0047",
    fill: "#00009E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43438 12.0043C8.42098 12.011 8.39557 11.9923 8.38358 12.0008V11.9934C8.39522 11.9853 8.42063 12.004 8.43438 11.9969V12.0047V12.0043Z",
    fill: "#002B7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43438 12.0121C8.42098 12.0188 8.39557 12.0001 8.38358 12.0082V12.0004C8.39522 11.9923 8.42063 12.011 8.43438 12.004V12.0117",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43438 12.0199C8.42098 12.0269 8.39557 12.0082 8.38358 12.0163V12.0086C8.39522 12.0004 8.42063 12.0191 8.43438 12.0125V12.0199Z",
    fill: "#FF0016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43438 12.0199C8.42098 12.0269 8.39557 12.0082 8.38358 12.0163V12.0086C8.39522 12.0004 8.42063 12.0191 8.43438 12.0125V12.0199Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43438 12.0276C8.42098 12.0347 8.39557 12.016 8.38358 12.0241V12.0163C8.39522 12.0086 8.42063 12.0269 8.43438 12.0199V12.0276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43438 12.035C8.42098 12.0421 8.39557 12.0234 8.38358 12.0315V12.0238C8.39522 12.0156 8.42063 12.0343 8.43438 12.0273V12.0347",
    fill: "#00009E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43438 12.035C8.42098 12.0421 8.39557 12.0234 8.38358 12.0315V12.0238C8.39522 12.0156 8.42063 12.0343 8.43438 12.0273V12.035Z",
    fill: "#002B7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2317 13.7044C8.06059 13.4608 7.72017 13.6409 7.27311 13.1939C6.9721 12.8918 6.98825 12.4646 7.07067 12.2809C7.15844 12.0848 7.28566 11.7999 7.17191 11.3493M9.32822 11.3484C9.21444 11.7981 9.34166 12.083 9.42945 12.28C9.51188 12.4637 9.528 12.891 9.22699 13.193C8.77996 13.64 8.43951 13.4599 8.2684 13.7035L9.32822 11.3484Z",
    stroke: "black",
    strokeWidth: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30114 10.2178C8.3074 10.247 8.31547 10.3255 8.27248 10.3367C8.3513 10.434 8.46508 10.4479 8.66486 10.4479C8.79028 10.4479 8.89152 10.447 8.96587 10.4479C8.96587 10.4728 8.95779 10.4995 8.95779 10.5306C8.95779 10.5605 8.98916 10.5744 9.03485 10.5641C9.08054 10.5537 9.17819 10.5244 9.23103 10.5709C9.31974 10.6503 9.48278 10.664 9.52667 10.714C9.51324 10.6536 9.4559 10.5925 9.3923 10.5416C9.45232 10.533 9.53025 10.5392 9.55713 10.5597C9.48902 10.4858 9.3654 10.4841 9.30268 10.4479C9.23997 10.4117 9.17994 10.3798 9.13338 10.3676C9.13338 10.3471 9.13067 10.3306 9.11275 10.3187C9.07333 10.2911 8.99629 10.2816 8.93359 10.2781C8.94254 10.2686 8.94432 10.2574 8.94432 10.2402V10.1429C8.94432 10.1092 8.94792 10.1006 8.90939 10.0765C8.76069 9.98524 8.57972 9.91974 8.25006 9.91974C7.92128 9.91974 7.74028 9.98435 7.59072 10.0765C7.55131 10.1006 7.5558 10.1092 7.5558 10.1429V10.2402C7.5558 10.2574 7.5567 10.2686 7.56653 10.2781C7.50383 10.2807 7.42769 10.2902 7.38737 10.3187C7.37035 10.3306 7.36675 10.3462 7.36675 10.3676C7.32107 10.3789 7.26105 10.4109 7.19745 10.4479C7.13473 10.4841 7.01112 10.4858 6.94302 10.5597C6.969 10.5392 7.04694 10.5321 7.10696 10.5416C7.04425 10.5917 6.98692 10.6528 6.97258 10.7141C7.01648 10.664 7.17952 10.6503 7.26912 10.571C7.32107 10.5244 7.41872 10.5529 7.4653 10.5641C7.51099 10.5745 7.54236 10.5615 7.54236 10.5306C7.54236 10.4995 7.53429 10.4728 7.53429 10.4479C7.60775 10.4461 7.70898 10.4479 7.8353 10.4479C8.03419 10.4479 8.14796 10.434 8.22768 10.3368C8.18378 10.3255 8.19185 10.2479 8.19901 10.2179C8.10585 10.1972 8.05927 10.1619 7.984 10.1619C7.90965 10.1619 7.89621 10.2014 7.89621 10.2161V10.2283C7.83709 10.2283 7.75377 10.2135 7.73317 10.1747C7.84784 10.1281 8.01806 10.086 8.25185 10.086C8.48567 10.086 8.65588 10.1281 8.77053 10.1747C8.74994 10.2135 8.66661 10.2283 8.6075 10.2283V10.2161C8.6075 10.2022 8.59495 10.1619 8.5197 10.1619C8.44446 10.1619 8.39785 10.1963 8.30469 10.2179H8.30112L8.30114 10.2178Z",
    fill: "#89C5E3",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89351 10.2289V10.2739C7.89351 10.303 7.92486 10.3409 7.97325 10.3409C8.0924 10.3409 8.1157 10.3204 8.20438 10.3228M7.53251 10.4494C7.47428 10.4503 7.43307 10.4538 7.41066 10.4607C7.37484 10.4719 7.37126 10.4909 7.39454 10.5012L7.53251 10.4494Z",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36407 10.3702V10.4589C7.36407 10.4832 7.38109 10.5167 7.44561 10.5039C7.50205 10.4935 7.53876 10.5063 7.53876 10.5306M8.20347 10.3204C8.12105 10.3065 8.05566 10.2626 7.98308 10.2626C7.91141 10.2626 7.89618 10.2953 7.90873 10.3109L8.20347 10.3204Z",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60483 10.2289V10.2739C8.60483 10.303 8.57348 10.3409 8.52509 10.3409C8.40594 10.3409 8.38264 10.3204 8.29396 10.3228M7.5647 10.2798C7.57813 10.2935 7.6077 10.3056 7.67311 10.329C7.79314 10.3729 8.06906 10.4029 8.24827 10.3246L7.5647 10.2798ZM8.76874 10.1746C8.79204 10.1841 8.81353 10.1936 8.83236 10.2031C8.94432 10.2591 8.9524 10.2721 8.91297 10.2935L8.76874 10.1746ZM8.96675 10.4494C9.02498 10.4503 9.0662 10.4538 9.0886 10.4607C9.12442 10.4719 9.128 10.4909 9.10472 10.5012L8.96675 10.4494Z",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13427 10.3702V10.4589C9.13427 10.4832 9.11725 10.5167 9.05274 10.5039C8.9963 10.4935 8.95956 10.5063 8.95956 10.5306M8.29483 10.3204C8.37729 10.3065 8.44268 10.2626 8.51527 10.2626C8.58692 10.2626 8.60217 10.2953 8.58873 10.3109L8.29483 10.3204Z",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93364 10.2798C8.9202 10.2935 8.89063 10.3056 8.82522 10.329C8.70519 10.3729 8.42927 10.4029 8.25006 10.3246",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24913 10.3409C8.30378 10.3409 8.30557 10.2997 8.30557 10.2617C8.30557 10.2247 8.30378 10.1832 8.24913 10.1832C8.19448 10.1832 8.19269 10.2247 8.19269 10.2617C8.19269 10.2988 8.19448 10.3409 8.24913 10.3409Z",
    fill: "#89C5E3",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73353 10.1747C7.70968 10.1842 7.68768 10.1937 7.66841 10.2031C7.55377 10.2591 7.54553 10.2721 7.58589 10.2934",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11834 10.9228C8.19359 10.8744 8.28677 10.793 8.3208 10.7391C8.36738 10.6639 8.37367 10.7006 8.40949 10.6944C8.32527 10.7866 8.22047 10.8852 8.14612 10.9373L8.11834 10.9228ZM7.48854 11.1038C7.30041 10.9971 7.22874 11.1083 7.18484 11.1136C7.23679 11.1262 7.28069 11.2095 7.48854 11.1038Z",
    fill: "#078930",
    stroke: "black",
    strokeWidth: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57276 11.0421C7.39357 10.921 7.31386 11.0267 7.26904 11.0295C7.32012 11.0455 7.35775 11.1324 7.57276 11.0421Z",
    fill: "#078930",
    stroke: "black",
    strokeWidth: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.7009 10.9703C7.5244 10.8457 7.442 10.9496 7.39719 10.9515C7.44826 10.9693 7.48319 11.0553 7.7009 10.9703Z",
    fill: "#078930",
    stroke: "black",
    strokeWidth: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8066 10.9068C7.64446 10.7634 7.55128 10.8584 7.50739 10.8547C7.55576 10.8781 7.58174 10.9675 7.8066 10.9068Z",
    fill: "#078930",
    stroke: "black",
    strokeWidth: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94184 10.8602C7.78687 10.7086 7.68922 10.7992 7.64532 10.793C7.6928 10.818 7.71431 10.9102 7.94184 10.8602Z",
    fill: "#078930",
    stroke: "black",
    strokeWidth: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08342 10.8448C7.95531 10.671 7.84424 10.7437 7.80124 10.7311C7.84335 10.7643 7.84961 10.8575 8.08342 10.8448Z",
    fill: "#078930",
    stroke: "black",
    strokeWidth: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10675 10.8519C8.10046 10.8127 8.027 10.7625 8.02074 10.7437C8.03955 10.7419 8.04223 10.7194 8.03418 10.7114C8.0279 10.7052 8.01267 10.7086 8.00462 10.7169C7.99654 10.7267 7.9885 10.7499 8.01446 10.7696C8.04134 10.7893 8.07539 10.8251 8.08615 10.8519",
    fill: "#078930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10675 10.8519C8.10046 10.8127 8.027 10.7625 8.02074 10.7437C8.03955 10.7419 8.04223 10.7194 8.03418 10.7114C8.0279 10.7052 8.01267 10.7086 8.00462 10.7169C7.99654 10.7267 7.9885 10.7499 8.01446 10.7696C8.04134 10.7893 8.07539 10.8251 8.08615 10.8519",
    stroke: "black",
    strokeWidth: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31747 11.1164C7.36853 11.101 7.43304 11.1083 7.47783 11.1037L7.31747 11.1164ZM7.40081 11.0411C7.45366 11.0294 7.51638 11.0411 7.56206 11.0411H7.40081ZM7.52892 10.9657C7.58176 10.9561 7.64448 10.9684 7.69016 10.9684L7.52892 10.9657ZM7.63639 10.8834C7.69015 10.879 7.75106 10.8987 7.79585 10.904L7.63639 10.8834ZM7.77257 10.8279C7.8263 10.826 7.88634 10.8485 7.93113 10.8565L7.77257 10.8279ZM7.92217 10.7866C7.97593 10.7921 8.03147 10.826 8.07358 10.8395L7.92217 10.7866Z",
    fill: "#078930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.92217 10.7866C7.97593 10.7921 8.03147 10.826 8.07358 10.8395M7.31747 11.1164C7.36853 11.101 7.43304 11.1083 7.47783 11.1037L7.31747 11.1164ZM7.40081 11.0411C7.45366 11.0294 7.51638 11.0411 7.56206 11.0411H7.40081ZM7.52892 10.9657C7.58176 10.9561 7.64448 10.9684 7.69016 10.9684L7.52892 10.9657ZM7.63639 10.8834C7.69015 10.879 7.75106 10.8987 7.79585 10.904L7.63639 10.8834ZM7.77257 10.8279C7.8263 10.826 7.88634 10.8485 7.93113 10.8565L7.77257 10.8279Z",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25009 10.9131C8.2922 10.9131 8.32802 10.9131 8.35401 10.9097V10.8496C8.35401 10.8299 8.42389 10.8065 8.52959 10.8271C8.94348 10.9079 8.99991 11.095 9.3144 11.2026C9.31797 11.2035 9.32963 11.2071 9.34306 11.2097C9.35114 11.1909 9.36008 11.1721 9.36994 11.1489C9.37531 11.1317 9.42102 11.1326 9.46131 11.1514C9.50792 11.1739 9.52851 11.1998 9.52046 11.2133C9.51238 11.2331 9.50431 11.2491 9.49715 11.2652C9.57062 11.2913 9.70409 11.3308 9.6602 11.5071C9.62616 11.4741 9.54374 11.4381 9.49269 11.4381C9.43445 11.4381 9.37173 11.4159 9.39146 11.3521C9.3807 11.3468 9.36187 11.337 9.35203 11.3351C9.35024 11.3406 9.34756 11.3459 9.34485 11.3512C9.33141 11.3844 9.27318 11.3961 9.21495 11.3764C8.88706 11.2645 8.78583 11.017 8.39881 11.0136V11.0244C8.39881 11.0556 8.3585 11.0842 8.25011 11.0842C8.14259 11.0842 8.1014 11.0556 8.1014 11.0244V11.0136C7.71529 11.0161 7.61313 11.2636 7.28526 11.3764C7.22793 11.3961 7.1697 11.3835 7.15536 11.3512C7.15355 11.3459 7.15087 11.3406 7.14818 11.3351C7.13832 11.337 7.11952 11.3468 7.10876 11.3521C7.12759 11.4149 7.06665 11.4381 7.00753 11.4381C6.95648 11.4381 6.87495 11.4741 6.84002 11.5071C6.79612 11.3317 6.92781 11.2922 7.00305 11.2652C6.99588 11.2491 6.98873 11.2331 6.97976 11.2133C6.9726 11.1998 6.9923 11.1739 7.03888 11.1514C7.0792 11.1317 7.12398 11.1308 7.13027 11.1489C7.14014 11.1711 7.14818 11.1899 7.15715 11.2097C7.17059 11.2071 7.18132 11.2035 7.18582 11.2026C7.49938 11.095 7.55671 10.9079 7.97058 10.8271C8.07541 10.8065 8.14619 10.8299 8.14619 10.8496V10.9097C8.17217 10.9122 8.208 10.9131 8.2501 10.9131H8.25009Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14528 10.9097C8.11751 10.9069 8.10139 10.9007 8.10139 10.8899C8.10139 10.8631 8.14528 10.8721 8.14528 10.8496V10.9097ZM7.0908 11.2044C7.10692 11.2429 7.12754 11.2922 7.14635 11.3342L7.0908 11.2044ZM7.05139 11.2241C7.06752 11.2617 7.09799 11.3262 7.10694 11.353L7.05139 11.2241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05139 11.2241C7.06752 11.2617 7.09799 11.3262 7.10694 11.353M8.14528 10.9097C8.11751 10.9069 8.10139 10.9007 8.10139 10.8899C8.10139 10.8631 8.14528 10.8721 8.14528 10.8496V10.9097ZM7.0908 11.2044C7.10692 11.2429 7.12754 11.2922 7.14635 11.3342L7.0908 11.2044Z",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12843 11.1489C7.13647 11.173 7.08003 11.1828 7.09168 11.2044C7.09886 11.2186 7.13022 11.2142 7.1553 11.2087M6.97702 11.2142C6.98777 11.233 7.04422 11.2053 7.05137 11.2232C7.05766 11.242 7.04064 11.2518 7.00121 11.2661L6.97702 11.2142Z",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10043 10.889V11.0136V10.889ZM8.35488 10.9097C8.38176 10.9069 8.39878 10.9007 8.39878 10.8899C8.39878 10.8631 8.35488 10.8721 8.35488 10.8496V10.9097ZM9.40932 11.2044C9.39319 11.2429 9.37258 11.2922 9.35377 11.3342L9.40932 11.2044ZM9.44873 11.2241C9.43258 11.2617 9.40212 11.3262 9.39318 11.353L9.44873 11.2241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44873 11.2241C9.43258 11.2617 9.40212 11.3262 9.39318 11.353M8.10043 10.889V11.0136V10.889ZM8.35488 10.9097C8.38176 10.9069 8.39878 10.9007 8.39878 10.8899C8.39878 10.8631 8.35488 10.8721 8.35488 10.8496V10.9097ZM9.40932 11.2044C9.39319 11.2429 9.37258 11.2922 9.35377 11.3342L9.40932 11.2044Z",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3717 11.1489C9.36365 11.173 9.42009 11.1828 9.40844 11.2044C9.40126 11.2186 9.36991 11.2142 9.34482 11.2087M9.5231 11.2142C9.51235 11.233 9.45591 11.2053 9.44875 11.2232C9.44247 11.242 9.45949 11.2518 9.49891 11.2661L9.5231 11.2142Z",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39969 10.889V11.0136V10.889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39969 10.889V11.0136",
    stroke: "black",
    strokeWidth: 0.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26933 11.3345L7.23462 11.2104L7.27786 11.1983C7.28892 11.1953 7.29713 11.1942 7.3025 11.1951C7.30786 11.196 7.31283 11.1987 7.31741 11.2034C7.322 11.208 7.32537 11.2142 7.32752 11.2219C7.33023 11.2316 7.33009 11.24 7.32709 11.2473C7.3241 11.2545 7.31852 11.2601 7.31037 11.264C7.31566 11.2659 7.32027 11.2683 7.32419 11.2713C7.32812 11.2742 7.33392 11.2799 7.3416 11.2882L7.36073 11.3089L7.33627 11.3158L7.31382 11.2929C7.30573 11.2847 7.30039 11.2796 7.29778 11.2777C7.29518 11.2758 7.29268 11.2746 7.29027 11.2743C7.28787 11.274 7.28429 11.2745 7.27955 11.2758L7.27532 11.277L7.28981 11.3288L7.26933 11.3345ZM7.26978 11.2572L7.28501 11.2529C7.29432 11.2503 7.30013 11.2482 7.30244 11.2467C7.30475 11.2452 7.30635 11.243 7.30723 11.24C7.30812 11.2371 7.30799 11.2336 7.30683 11.2295C7.30573 11.2255 7.30405 11.2226 7.3018 11.2206C7.29964 11.2187 7.29687 11.2176 7.29398 11.2175C7.29189 11.2174 7.28625 11.2186 7.27705 11.2212L7.26097 11.2257L7.26978 11.2572ZM7.38336 11.3012L7.32618 11.1857L7.39642 11.151L7.40609 11.1705L7.3549 11.1958L7.36758 11.2214L7.41514 11.1979L7.42478 11.2173L7.37721 11.2409L7.39278 11.2723L7.4457 11.2461L7.45533 11.2655L7.38336 11.3012ZM7.4763 11.2521L7.40649 11.1439L7.43529 11.1253C7.44603 11.1184 7.45338 11.1144 7.45734 11.1133C7.46369 11.1115 7.47034 11.1123 7.47728 11.1156C7.48423 11.1188 7.49048 11.1248 7.49604 11.1334C7.50108 11.1412 7.50383 11.1487 7.5043 11.1559C7.50475 11.1631 7.50346 11.1692 7.50041 11.1742C7.49736 11.1792 7.49042 11.1852 7.47958 11.1922L7.46784 11.1998L7.49417 11.2406L7.4763 11.2521ZM7.43618 11.1507L7.45598 11.1814L7.46588 11.175C7.47252 11.1707 7.47674 11.1673 7.47852 11.1649C7.48031 11.1624 7.48118 11.1594 7.48114 11.156C7.48109 11.1526 7.47993 11.1491 7.47764 11.1456C7.47533 11.142 7.47258 11.1394 7.46942 11.138C7.46626 11.1366 7.46325 11.1362 7.4604 11.1368C7.45754 11.1375 7.45237 11.1402 7.44489 11.145L7.43618 11.1507ZM7.48433 11.0945L7.50176 11.0824L7.54173 11.1396C7.54793 11.1484 7.55219 11.1541 7.5545 11.1565C7.55852 11.1606 7.56288 11.1629 7.56756 11.1634C7.57225 11.1639 7.57696 11.1625 7.58172 11.1592C7.58575 11.1564 7.58841 11.1532 7.5897 11.1496C7.59099 11.146 7.59098 11.1423 7.58969 11.1385C7.58839 11.1346 7.58407 11.1275 7.57672 11.1169L7.53591 11.0585L7.55341 11.0463L7.59216 11.1017C7.60206 11.1159 7.60846 11.1267 7.61136 11.1341C7.61426 11.1414 7.61442 11.1489 7.61185 11.1565C7.60928 11.1642 7.60365 11.171 7.59495 11.1771C7.58592 11.1834 7.57774 11.1867 7.57041 11.187C7.56308 11.1873 7.55622 11.1853 7.54983 11.181C7.54344 11.1767 7.53473 11.1667 7.52369 11.1509L7.48433 11.0945ZM7.57325 11.0302L7.6088 11.0073C7.6185 11.0011 7.6259 10.9976 7.63098 10.9968C7.63606 10.9961 7.6414 10.9971 7.64699 10.9998C7.65259 11.0025 7.65721 11.0067 7.66086 11.0124C7.66422 11.0176 7.66609 11.0231 7.66649 11.0288C7.66688 11.0345 7.66589 11.0395 7.66349 11.0439C7.66997 11.0424 7.67615 11.043 7.68205 11.0456C7.68794 11.0482 7.69298 11.0528 7.69717 11.0593C7.70224 11.0671 7.70463 11.075 7.70434 11.0829C7.70405 11.0908 7.70174 11.097 7.69739 11.1016C7.69436 11.1048 7.6863 11.1107 7.67319 11.1191L7.64297 11.1385L7.57325 11.0302ZM7.60274 11.0367L7.61886 11.0618L7.63068 11.0542C7.63778 11.0496 7.64208 11.0467 7.6436 11.0453C7.64634 11.0429 7.64789 11.0401 7.64827 11.0369C7.64865 11.0337 7.64768 11.0303 7.64536 11.0267C7.6433 11.0235 7.64093 11.0213 7.63824 11.0202C7.63555 11.0191 7.63305 11.019 7.63074 11.0198C7.62843 11.0206 7.62254 11.024 7.61309 11.0301L7.60274 11.0367ZM7.63046 11.0798L7.64911 11.1088L7.66573 11.0981C7.67302 11.0934 7.67745 11.09 7.67903 11.0879C7.68061 11.0858 7.68139 11.0832 7.68134 11.08C7.68131 11.0769 7.68018 11.0736 7.67796 11.0702C7.67567 11.0666 7.67304 11.0642 7.67007 11.0629C7.66724 11.0615 7.66406 11.0612 7.66104 11.062C7.65799 11.0627 7.65263 11.0656 7.64494 11.0705L7.63046 11.0798ZM7.72544 11.0824L7.66642 10.9691L7.68528 10.9593L7.73427 11.0533L7.78135 11.0288L7.79138 11.0481L7.72544 11.0824ZM7.80523 11.0394L7.75541 10.9205L7.77503 10.9123L7.82484 11.0311L7.80523 11.0394ZM7.89023 10.9624L7.91231 10.9642C7.91335 10.9789 7.91124 10.9905 7.90596 10.999C7.90068 11.0076 7.89279 11.0134 7.8823 11.0165C7.8691 11.0205 7.85689 11.0186 7.84566 11.0109C7.83272 11.002 7.82327 10.9876 7.81731 10.9676C7.81101 10.9466 7.81083 10.9287 7.81675 10.914C7.82191 10.9012 7.83145 10.8927 7.84537 10.8885C7.8567 10.8851 7.86735 10.8862 7.8773 10.8916C7.88439 10.8955 7.89082 10.9025 7.89658 10.9126L7.87814 10.9245C7.87485 10.9182 7.87076 10.9138 7.86584 10.9114C7.86093 10.909 7.85587 10.9086 7.85065 10.9102C7.84318 10.9124 7.83807 10.9175 7.8353 10.9254C7.83253 10.9333 7.83339 10.9448 7.83788 10.9597C7.84253 10.9753 7.84814 10.9857 7.85471 10.9908C7.86127 10.996 7.86823 10.9975 7.87559 10.9953C7.88097 10.9937 7.88501 10.9902 7.88768 10.9849C7.89036 10.9795 7.89121 10.972 7.89023 10.9624ZM8.02927 10.9782L8.00646 10.9824L7.99202 10.9554L7.95055 10.9631L7.94738 10.9935L7.92509 10.9976L7.94184 10.8635L7.96404 10.8593L8.02927 10.9782ZM7.98129 10.9353L7.95825 10.891L7.95296 10.9406L7.98129 10.9353ZM8.16152 10.9292L8.1994 10.9321C8.20898 10.9328 8.21612 10.9344 8.22083 10.9369C8.22554 10.9394 8.22976 10.9434 8.23348 10.9488C8.2372 10.9542 8.23992 10.961 8.24164 10.9693C8.24336 10.9775 8.24376 10.9877 8.24285 10.9997C8.24203 11.0105 8.24009 11.0199 8.23703 11.0277C8.23397 11.0355 8.23039 11.0416 8.22626 11.046C8.22229 11.0503 8.21733 11.0536 8.21182 11.0555C8.20632 11.0575 8.19937 11.0582 8.19099 11.0575L8.152 11.0546L8.16152 10.9292ZM8.1806 10.952L8.1743 11.035L8.18986 11.0362C8.19653 11.0367 8.20141 11.0364 8.20449 11.0354C8.2075 11.0344 8.21019 11.0327 8.21228 11.0303C8.21438 11.0279 8.21627 11.024 8.21794 11.0186C8.21961 11.0132 8.22078 11.0061 8.22146 10.9971C8.22217 10.9878 8.22208 10.9805 8.22121 10.975C8.22033 10.9696 8.21866 10.9652 8.21618 10.9619C8.21383 10.9587 8.21054 10.9563 8.20677 10.9551C8.20392 10.9541 8.19833 10.9533 8.19001 10.9527L8.1806 10.952ZM8.26983 11.0609L8.26188 10.9354L8.33821 10.9306L8.33955 10.9518L8.28393 10.9554L8.28569 10.9832L8.33738 10.9799L8.33872 11.001L8.28703 11.0043L8.2892 11.0384L8.34671 11.0348L8.34804 11.0559L8.26983 11.0609ZM8.5024 10.9408L8.52261 10.9499C8.51864 10.9641 8.51273 10.9744 8.50489 10.9806C8.49706 10.9869 8.48767 10.9897 8.47673 10.9891C8.46298 10.9884 8.45211 10.9825 8.44413 10.9715C8.43494 10.9587 8.43089 10.942 8.43197 10.9212C8.43313 10.8993 8.43897 10.8824 8.44951 10.8705C8.45867 10.8602 8.4705 10.8554 8.48501 10.8561C8.49683 10.8568 8.50651 10.8613 8.51404 10.8698C8.51942 10.8758 8.52312 10.8846 8.52516 10.896L8.50378 10.901C8.5028 10.894 8.5004 10.8885 8.49659 10.8846C8.49278 10.8807 8.48815 10.8786 8.48271 10.8783C8.47493 10.8779 8.46841 10.8809 8.46313 10.8875C8.45786 10.894 8.45482 10.9051 8.454 10.9207C8.45316 10.9369 8.45495 10.9486 8.45939 10.9556C8.46382 10.9627 8.46988 10.9665 8.47754 10.9669C8.48316 10.9672 8.48813 10.9653 8.49245 10.9611C8.49677 10.957 8.50009 10.9502 8.5024 10.9408V10.9408ZM8.54989 10.9292C8.55355 10.9143 8.55877 10.9025 8.56556 10.894C8.57234 10.8854 8.57986 10.8796 8.58814 10.8767C8.59641 10.8737 8.60561 10.8735 8.61573 10.8759C8.63041 10.8796 8.64099 10.8881 8.64748 10.9016C8.65397 10.9151 8.65467 10.9322 8.64957 10.9529C8.64442 10.9738 8.63551 10.9889 8.62282 10.9983C8.61168 11.0066 8.59874 11.009 8.584 11.0053C8.56915 11.0017 8.5587 10.9936 8.55264 10.9812C8.54575 10.9671 8.54483 10.9497 8.54989 10.9292ZM8.57143 10.9336C8.56789 10.9479 8.56797 10.9594 8.57166 10.968C8.57535 10.9765 8.58123 10.9817 8.58931 10.9837C8.59744 10.9857 8.60506 10.9838 8.61217 10.978C8.61927 10.9722 8.62464 10.9619 8.62828 10.9471C8.63185 10.9326 8.63188 10.9212 8.62839 10.913C8.62489 10.9048 8.61893 10.8996 8.61051 10.8976C8.60209 10.8955 8.59438 10.8973 8.58736 10.903C8.58035 10.9087 8.57504 10.9189 8.57143 10.9336ZM8.66114 10.9815L8.68128 10.9874C8.67701 11.0034 8.68085 11.014 8.69282 11.0191C8.69876 11.0216 8.70408 11.022 8.70879 11.0204C8.71351 11.0187 8.71684 11.0156 8.71878 11.011C8.71993 11.0083 8.7203 11.0058 8.71992 11.0034C8.71953 11.001 8.71838 10.9987 8.71647 10.9964C8.71456 10.9942 8.70955 10.9897 8.70143 10.9828C8.69415 10.9768 8.68919 10.9714 8.68657 10.9668C8.68395 10.9622 8.68251 10.957 8.68227 10.9512C8.68203 10.9454 8.68308 10.9397 8.68544 10.9341C8.68819 10.9277 8.69213 10.9225 8.69726 10.9185C8.7024 10.9146 8.70812 10.9124 8.71442 10.912C8.72071 10.9115 8.72766 10.9129 8.73527 10.9161C8.7467 10.921 8.75431 10.9279 8.7581 10.9368C8.76188 10.9457 8.76151 10.9561 8.75699 10.9677L8.73689 10.9605C8.73873 10.9537 8.73876 10.9485 8.73697 10.9447C8.73519 10.941 8.73166 10.938 8.72637 10.9358C8.72109 10.9335 8.71654 10.9329 8.71275 10.9339C8.70895 10.9349 8.70636 10.937 8.70496 10.9403C8.70359 10.9436 8.70373 10.9468 8.70538 10.9501C8.70703 10.9535 8.71196 10.9584 8.72017 10.965C8.72882 10.9721 8.73468 10.9781 8.73773 10.9831C8.74079 10.9881 8.74242 10.9936 8.74262 10.9996C8.74283 11.0056 8.74141 11.0121 8.73839 11.0192C8.73402 11.0295 8.72718 11.0368 8.71787 11.0412C8.70856 11.0455 8.69716 11.0448 8.68367 11.0391C8.65984 11.029 8.65233 11.0098 8.66114 10.9815ZM8.7604 11.0739L8.81255 10.9804L8.78515 10.9651L8.79577 10.9461L8.86906 10.987L8.85845 11.006L8.83112 10.9908L8.77898 11.0842L8.7604 11.0739ZM8.89769 11.1594L8.87828 11.1467L8.88661 11.1171L8.85134 11.094L8.82802 11.1137L8.80906 11.1013L8.91408 11.0161L8.93296 11.0285L8.89769 11.1594ZM8.89278 11.0952L8.90686 11.0473L8.86867 11.0794L8.89278 11.0952ZM8.94019 11.1901L9.01371 11.0843L9.05058 11.11C9.06002 11.1165 9.06609 11.1221 9.06881 11.1268C9.07153 11.1316 9.07256 11.1372 9.0719 11.1437C9.07123 11.1502 9.06863 11.1567 9.06408 11.1632C9.05833 11.1715 9.05172 11.1768 9.04424 11.1791C9.03676 11.1814 9.02891 11.1806 9.0207 11.1768C9.02257 11.1821 9.02363 11.1872 9.02386 11.1921C9.02409 11.197 9.02345 11.2051 9.02193 11.2163L9.01812 11.2443L8.99727 11.2298L9.00057 11.1979C9.00178 11.1864 9.0023 11.1791 9.00212 11.1758C9.00193 11.1726 9.0012 11.17 8.99993 11.1679C8.99865 11.1658 8.99599 11.1634 8.99196 11.1606L8.98835 11.1581L8.95765 11.2022L8.94019 11.1901ZM9.00008 11.1412L9.01307 11.1502C9.02101 11.1557 9.0263 11.1589 9.02895 11.1597C9.0316 11.1605 9.03434 11.1603 9.03715 11.1592C9.03997 11.158 9.0426 11.1556 9.04504 11.1521C9.04738 11.1487 9.04859 11.1456 9.04867 11.1426C9.04877 11.1397 9.04787 11.1369 9.04611 11.1346C9.04484 11.1329 9.04029 11.1293 9.03245 11.1239L9.01874 11.1144L9.00008 11.1412ZM9.02727 11.2502L9.09816 11.1426L9.11591 11.1543L9.04502 11.2619L9.02727 11.2502ZM9.14402 11.2663L9.15797 11.2835C9.14802 11.2944 9.13814 11.3009 9.12833 11.3029C9.11852 11.305 9.10886 11.3033 9.09935 11.2978C9.0874 11.291 9.08034 11.2809 9.07818 11.2674C9.07572 11.2519 9.07965 11.2351 9.08997 11.2171C9.10088 11.198 9.11371 11.1855 9.12847 11.1797C9.1413 11.1746 9.15402 11.1757 9.16664 11.1829C9.1769 11.1887 9.18349 11.1972 9.1864 11.2081C9.18847 11.2159 9.18786 11.2254 9.18453 11.2365L9.16317 11.2314C9.16546 11.2247 9.16579 11.2187 9.16415 11.2135C9.16252 11.2083 9.15933 11.2043 9.1546 11.2016C9.14784 11.1977 9.14063 11.1975 9.13299 11.201C9.12535 11.2044 9.11764 11.213 9.10987 11.2265C9.10182 11.2406 9.09817 11.2518 9.09894 11.2602C9.0997 11.2685 9.10342 11.2746 9.11008 11.2784C9.11496 11.2812 9.12027 11.2817 9.12599 11.2799C9.13172 11.2782 9.13773 11.2736 9.14402 11.2663ZM9.24383 11.3597L9.2221 11.3516L9.22372 11.321L9.18421 11.3062L9.16581 11.3306L9.14457 11.3226L9.22823 11.2164L9.24939 11.2243L9.24383 11.3597ZM9.2249 11.2982L9.22807 11.2484L9.19791 11.2881L9.2249 11.2982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74657 10.1426L7.72868 10.1507L7.71137 10.1313L7.67884 10.146L7.68234 10.1716L7.66485 10.1795L7.65167 10.0659L7.66908 10.058L7.74657 10.1426ZM7.69852 10.117L7.67068 10.0852L7.6763 10.127L7.69852 10.117ZM7.75554 10.1399L7.7214 10.0363L7.74703 10.0279L7.78572 10.0934L7.77768 10.0178L7.80338 10.0093L7.83753 10.1128L7.82164 10.1181L7.79476 10.0366L7.80476 10.1236L7.78824 10.1291L7.74462 10.0531L7.7715 10.1346L7.75554 10.1399ZM7.85507 10.1083L7.82898 10.0025L7.89338 9.98663L7.89779 10.0045L7.85086 10.0161L7.85664 10.0396L7.90025 10.0288L7.90464 10.0466L7.86104 10.0574L7.86814 10.0862L7.91665 10.0742L7.92105 10.0921L7.85507 10.1083ZM7.93607 10.0889L7.91671 9.98165L7.9541 9.9749C7.96366 9.97317 7.97067 9.97291 7.97511 9.97409C7.97955 9.97528 7.98352 9.97802 7.98702 9.98229C7.99051 9.98658 7.99285 9.99203 7.99405 9.99867C7.99557 10.0071 7.99477 10.0142 7.99167 10.02C7.98858 10.0259 7.98343 10.0301 7.97626 10.0328C7.98055 10.0348 7.98424 10.0372 7.98732 10.04C7.99039 10.0428 7.99483 10.048 8.00064 10.0557L8.0151 10.0747L7.99395 10.0785L7.97686 10.0575C7.9707 10.0499 7.9666 10.0451 7.96456 10.0433C7.96252 10.0415 7.9605 10.0403 7.9585 10.0399C7.9565 10.0394 7.95345 10.0395 7.94936 10.0403L7.9457 10.0409L7.95378 10.0857L7.93607 10.0889ZM7.9426 10.0238L7.95577 10.0214C7.96382 10.02 7.96888 10.0187 7.97095 10.0176C7.97301 10.0165 7.97454 10.0148 7.97552 10.0124C7.9765 10.01 7.97666 10.007 7.97602 10.0034C7.97541 10 7.97422 9.9974 7.97249 9.99557C7.97082 9.99378 7.96858 9.99262 7.96615 9.99229C7.9644 9.99206 7.95954 9.99266 7.95159 9.99409L7.93769 9.9966L7.9426 10.0238ZM8.02433 10.074L8.00955 9.96598L8.02738 9.96353L8.04216 10.0715L8.02433 10.074ZM8.11251 10.0236L8.13055 10.0287C8.129 10.0411 8.12534 10.0504 8.11956 10.0566C8.11377 10.0628 8.10627 10.0664 8.09705 10.0673C8.08545 10.0684 8.07562 10.0648 8.06756 10.0566C8.05829 10.047 8.05281 10.0335 8.05113 10.016C8.04935 9.99751 8.05213 9.98263 8.05947 9.97137C8.06585 9.9616 8.07516 9.95612 8.0874 9.95495C8.09736 9.95399 8.10603 9.9566 8.1134 9.96276C8.11865 9.96714 8.12284 9.97398 8.12597 9.98329L8.1087 9.99018C8.107 9.98441 8.10432 9.98013 8.10064 9.97732C8.09712 9.97456 8.09267 9.97328 8.08823 9.97377C8.08167 9.97439 8.07659 9.97777 8.07299 9.98389C8.0694 9.99001 8.06823 9.99966 8.0695 10.0128C8.07081 10.0265 8.07376 10.036 8.07836 10.0414C8.08295 10.0468 8.08849 10.0492 8.09496 10.0486C8.09969 10.0481 8.10361 10.0459 8.10671 10.0419C8.10981 10.0379 8.11175 10.0318 8.11251 10.0236H8.11251ZM8.22963 10.0577L8.21002 10.0585L8.20123 10.0341L8.16557 10.0355L8.1592 10.0605L8.14003 10.0613L8.17045 9.951L8.18955 9.95024L8.22963 10.0577ZM8.1947 10.016L8.18083 9.97604L8.17033 10.0169L8.1947 10.016ZM8.33257 10.0198L8.34981 10.0271C8.34667 10.0392 8.34184 10.048 8.33531 10.0534C8.32878 10.0588 8.32088 10.0614 8.31162 10.061C8.29997 10.0607 8.29069 10.0559 8.28376 10.0466C8.27578 10.036 8.27209 10.0219 8.27268 10.0043C8.27331 9.98573 8.27799 9.97133 8.28672 9.96111C8.29431 9.95224 8.30425 9.94801 8.31653 9.94843C8.32654 9.94876 8.33479 9.95246 8.3413 9.95953C8.34594 9.96455 8.34922 9.97187 8.35113 9.98151L8.33311 9.98611C8.33217 9.98017 8.33006 9.97558 8.32677 9.97232C8.32365 9.96913 8.3194 9.96729 8.31493 9.96719C8.30834 9.96697 8.30287 9.96966 8.29851 9.97527C8.29416 9.98088 8.29176 9.99029 8.29132 10.0035C8.29085 10.0172 8.29255 10.0271 8.29642 10.033C8.30029 10.0389 8.30546 10.042 8.31195 10.0422C8.31671 10.0424 8.32089 10.0407 8.32448 10.0371C8.32807 10.0335 8.33077 10.0278 8.33257 10.0198V10.0198ZM8.36412 10.0615L8.37355 9.95291L8.43963 9.95864L8.43803 9.97701L8.38988 9.97284L8.38779 9.99691L8.43254 10.0008L8.43095 10.0191L8.38621 10.0152L8.38364 10.0448L8.43342 10.0491L8.43183 10.0674L8.36412 10.0615ZM8.44722 10.0691L8.46265 9.9612L8.48002 9.96368L8.50593 10.0409L8.51623 9.96886L8.53287 9.97123L8.51745 10.0791L8.49948 10.0766L8.47392 10.0011L8.46386 10.0715L8.44722 10.0691ZM8.55585 10.0865L8.57368 9.99766L8.54765 9.99244L8.55128 9.97436L8.6209 9.98833L8.61727 10.0064L8.59132 10.0012L8.57349 10.09L8.55585 10.0865ZM8.61109 10.0978L8.63894 9.99245L8.67568 10.0022C8.68507 10.0046 8.69153 10.0074 8.69506 10.0103C8.69858 10.0133 8.70102 10.0174 8.70237 10.0228C8.70373 10.0281 8.70354 10.0341 8.70182 10.0406C8.69964 10.0488 8.69591 10.055 8.69063 10.059C8.68534 10.0629 8.67889 10.0646 8.67126 10.064C8.67429 10.0677 8.6766 10.0714 8.6782 10.0752C8.67981 10.0791 8.68163 10.0857 8.68367 10.095L8.68873 10.1184L8.66795 10.1129L8.66136 10.0866C8.65899 10.0771 8.65724 10.0711 8.65616 10.0686C8.65511 10.0661 8.65375 10.0642 8.65214 10.0629C8.65053 10.0616 8.64768 10.0605 8.64368 10.0594L8.64008 10.0584L8.62845 10.1024L8.61109 10.0978ZM8.64456 10.0416L8.6575 10.045C8.66541 10.0471 8.67053 10.0481 8.67287 10.048C8.67521 10.0479 8.67733 10.0469 8.67923 10.0452C8.68113 10.0434 8.68254 10.0408 8.68346 10.0373C8.68436 10.0339 8.6844 10.0311 8.68359 10.0287C8.68283 10.0263 8.6813 10.0244 8.67924 10.023C8.67775 10.0221 8.6731 10.0206 8.66529 10.0185L8.65163 10.0149L8.64456 10.0416ZM8.77428 10.1476L8.75572 10.1412L8.75638 10.1152L8.72262 10.1037L8.70761 10.1247L8.68947 10.1185L8.75779 10.0267L8.77586 10.0329L8.77428 10.1476ZM8.75686 10.096L8.75839 10.0538L8.73379 10.0881L8.75686 10.096ZM8.78348 10.1516L8.82688 10.0526L8.84336 10.0598L8.80733 10.142L8.84846 10.16L8.84109 10.1768L8.78348 10.1516Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.2502 13.8996) scale(0.0514344 0.0508414)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.35686 13.8994) scale(0.0346376 0.034214)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.25054 14.0073) scale(0.0342499 0.0345303)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.14328 13.9011) scale(0.0346376 0.0343281)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.24958 13.7932) scale(0.0342499 0.034445)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.66443 12.2227) rotate(180) scale(0.0555553 0.0551692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.79703 12.2162) rotate(180) scale(0.0555551 0.0551692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.92785 12.2227) rotate(180) scale(0.0555551 0.0551692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.61605 12.3401) rotate(180) scale(0.0555551 0.0550553)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.74686 12.3401) rotate(180) scale(0.0555551 0.0550553)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.87855 12.3401) rotate(180) scale(0.0555553 0.0550553)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.61071 12.4629) rotate(180) scale(0.0555551 0.0551687)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.73437 12.4582) rotate(180) scale(0.0555553 0.0551692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.86597 12.4582) rotate(180) scale(0.0555553 0.0551692)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.62983 12.5851) rotate(180) scale(0.052528 0.0519585)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.75333 12.5851) rotate(180) scale(0.052362 0.0519607)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.878 12.5851) rotate(180) scale(0.0525372 0.0519593)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.65812 12.7125) rotate(180) scale(0.0502346 0.0498619)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.77064 12.6992) rotate(180) scale(0.0502346 0.0498352)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.88977 12.6939) rotate(180) scale(0.0502344 0.0498628)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.7043 12.8216) rotate(180) scale(0.048278 0.0477556)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.80688 12.8055) rotate(180) scale(0.0459154 0.045876)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.91575 12.7915) rotate(180) scale(0.0374845 0.037382)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.75048 12.9202) rotate(180) scale(0.0459154 0.0458765)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.84945 12.8896) rotate(180) scale(0.0385089 0.0387745)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.94126 12.8708) rotate(180) scale(0.0324408 0.0323256)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.79774 13.0066) rotate(180) scale(0.0430681 0.0429963)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.88391 12.9649) rotate(180) scale(0.0359571 0.0361718)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.96621 12.9345) rotate(180) scale(0.0306409 0.0305694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.85881 13.0837) rotate(180) scale(0.0397916 0.0398925)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.93359 13.0357) rotate(180) scale(0.0336912 0.0336579)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.0052 12.9993) rotate(180) scale(0.0281076 0.028301)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.90975 13.1483) rotate(180) scale(0.0366998 0.0363807)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.97348 13.0984) rotate(180) scale(0.0305257 0.0309234)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.03529 13.0593) rotate(180) scale(0.0260771 0.0262163)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.97035 13.2006) rotate(180) scale(0.0311623 0.0314694)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.02259 13.1557) rotate(180) scale(0.0264 0.0265536)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.07378 13.1198) rotate(180) scale(0.0220532 0.022592)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.02359 13.2471) rotate(180) scale(0.0289891 0.0292216)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.06696 13.2022) rotate(180) scale(0.0244203 0.0248339)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.11043 13.1643) rotate(180) scale(0.020715 0.0208939)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.07484 13.2883) rotate(180) scale(0.0289889 0.0291603)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.11824 13.2444) rotate(180) scale(0.0244205 0.0246779)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.15343 13.2062) rotate(180) scale(0.0207197 0.0210659)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.19285 13.2482) rotate(180) scale(0.0190859 0.0195354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.1606 13.286) rotate(180) scale(0.0207147 0.020829)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.12569 13.3251) rotate(180) scale(0.0223621 0.0227449)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.23448 13.2909) rotate(180) scale(0.0178678 0.0180632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.20858 13.3242) rotate(180) scale(0.0190812 0.0193456)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.17721 13.3569) rotate(180) scale(0.0203274 0.0204756)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.27444 13.319) rotate(180) scale(0.0162295 0.0166636)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.25127 13.3504) rotate(180) scale(0.0178632 0.0182402)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.22258 13.3849) rotate(180) scale(0.0186799 0.0192729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.30821 13.3443) rotate(180) scale(0.0157679 0.0160244)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.28714 13.3733) rotate(180) scale(0.0167695 0.0170861)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.26709 13.4044) rotate(180) scale(0.0180154 0.0186169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.34043 13.3628) rotate(180) scale(0.0140881 0.0142266)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.32364 13.393) rotate(180) scale(0.0150252 0.0152639)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.30726 13.4224) rotate(180) scale(0.0160266 0.0161119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.37439 13.3795) rotate(180) scale(0.0135949 0.0136608)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.36244 13.4068) rotate(180) scale(0.0144068 0.0146744)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.34555 13.4375) rotate(180) scale(0.0155882 0.0158316)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.40509 13.3979) rotate(180) scale(0.0115644 0.011871)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.39602 13.4232) rotate(180) scale(0.0125701 0.0124296)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.38339 13.4491) rotate(180) scale(0.013447 0.0134824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_5819_33118",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.00121 12.1316) rotate(180) scale(0.0374106 0.0372827)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8E32"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostaRica);
export default __webpack_public_path__ + "static/media/Costa-Rica.8caef231baeb1c0d27ba49d0c3f33ab1.svg";
export { ForwardRef as ReactComponent };